import { Component, ViewChild } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import {
  AgencyMasterProperties,
  AgencyBaseDataProperties,
  ReportTypesAgency,
  ReportTypesUser,
  CustomerCodes,
  UrlRequest,
  CreditLimitChecking,
  SupplierRightsForAgencyAndBranchProperties,
  SuppliersOfficeIds,
  SupplierRightsForAgencyAndBranchBooleanProperties,
  BackSystemCreditRequest,
  BackSystemCreditLimitProperties,
} from "../Models/AgencyMasterProperties";
import {
  B2BActiveBranches, CustomerSaleOrder, ActiveAgencies, ActiveCurrencies,
  ActiveLanguages, ActiveAgenciesTypes, ParentUsers, Agency_Branches, ActiveAgencyGroups
} from "../Models/ActiveClasses";
import { AgencyService } from "../Services/Agency.service";
import { ManagerProperties } from "../Models/ManagerProperties";
import { environment } from "../../environments/environment";
import { HttpClient, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http'
import { Router } from "@angular/router";
import { stringify } from "querystring";
import { UserAdminControlRightsProperties, UserAgentRightsProperties, UserRightsDisabledProperties, UsersProperties } from "../Models/UsersProperties";
import { AgencySupplierRightsdata, AgencySupplierRightsList } from "../Models/SuppliersProperties";
import { ItemsList } from "@ng-select/ng-select/lib/items-list";
import { AgencyRightsProperties, ReportAgencyRightsProperties } from "../Models/AgencyRightsProperties";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BackSystemCompanyId, BackSystemAllList, BackSystemOfficeProperties, ParentBackSystemCompanies } from "../Models/BranchInformationProperties";
import { Countries } from "../Models/Countries";
import { NgSelectComponent } from "@ng-select/ng-select";
import { CompanyMasterProperties } from "../Models/CompanyMasterProperties";
import { document } from "ngx-bootstrap/utils";
import { MessageService } from "primeng/api";
import { RegisterUserProperties } from "../register/RegisterProperties";
declare var $;


@Component({
  selector: "app-agency-master",
  templateUrl: "./agency-master.component.html",
  styleUrls: ["./agency-master.component.css"],
})
/** AgencyMaster component*/
export class AgencyMasterComponent {
  loaderVar: boolean;
  userlimitreached: boolean = false; ImmediateParent: string;
  ;
  constructor(private messageservice: MessageService, private agencyService: AgencyService, private http: HttpClient, private router: Router) { }
  agencyObj = new AgencyMasterProperties();
  supplierRightsData = new AgencySupplierRightsdata();
  userRightDisable = new UserRightsDisabledProperties();
  customerCodeList$: Observable<CustomerSaleOrder[]>;
  branchCodeList$: Observable<B2BActiveBranches[]>;
  agencyCodeList$: Observable<Agency_Branches[]>;
  currencyCodeList$: Observable<ActiveCurrencies[]>;
  languageCodeList$: Observable<ActiveLanguages[]>;
  agencyTypeList$: Observable<ActiveAgenciesTypes[]>;
  agencyGroupList$: Observable<ActiveAgencyGroups[]>;
  managerUserList$: Observable<ParentUsers[]>;
  parentUsertList: ParentUsers[] = [];
  managerList: ManagerProperties[] = [];
  allBaseData$: AgencyBaseDataProperties;
  backsystemOfficeProperties: BackSystemOfficeProperties[] = [];
  agencyInfoComplete = true;
  BackOfficeInfoComplete = false;
  managerInfoComplete = false;
  adminInfoComplete = false;
  settleModeComplete = false;
  logoInfoComplete = false;
  agencyRightsComplete = false;
  supplierRightsComplete = false;
  supplierStep = false;
  stepOne = true;
  stepTwo = false;
  stepThree = false;
  stepFour = false;
  stepFive = false;
  stepSix = false;
  stepSeven = false;
  stepEight = false;
  settelementCash = false;
  settelementCredit = false;
  baseUrl = environment.baseUrl;
  checkImgUpload = false;
  public progress: number;
  creditReadOnly = true;
  imageSource: any;
  creditCheck = false;
  isAgency = false;
  disablefileupload: boolean = false;
  currencyRight = false;
  agencyRight = false;
  agencyColor = "hsl(40,100%,50%)";
  creationAgency = "";
  agencyBlock = false;
  immediateParentBlock = false;
  accountRight = false;
  agr_profileDisabled = false;
  agr_BeneficiaryDisabled = false;
  agr_PaymentDisabled = false;
  agr_CreditDisabled = false;
  agr_NoticationsDisabled = false;
  agr_ServiceFeeDisabled = false;
  agr_OfflineRequestDisabled = false;
  agr_OfflineSettingsDisabled = false;
  agr_SupplierDisabled = false;
  agr_AccountManagementDisabled = false;
  agr_BookingsDisabled = false;
  agr_CmsDisabled = false;
  agr_ReportsDisabled = false;
  agr_DashboardDisabled = false;
  agr_AddPaymentDisabled = false;
  agr_ApprovePaymentDisabled = false;
  agr_DeletePaymentDisabled = false;
  agr_AccountDisabled = false;
  agr_UsersDisabled = false;
  agr_LogsDisabled = false;
  agr_CurrencyDisabled = false;
  agr_SearchBookingsDisabled = false;
  agr_ViewBookingsDisabled = false;
  agr_UpdateBookingsDisabled = false;
  ag_offlineBookingsDisabled: boolean = false;
  ag_offlineTicketDisabled: boolean = false;
  ag_offlineVoidDisabled: boolean = false;
  ag_offlineRefundDisabled: boolean = false;
  ag_offlineDealsDisabled: boolean = false;
  isDisabled: boolean = false;
  flag = false;
  reportTypesAgency: ReportTypesAgency[] = [];
  reportTypesUser: ReportTypesUser[] = [];
  reportRights: ReportAgencyRightsProperties[] = [];
  countryList: Countries[] = [];
  codes: CustomerCodes[] = [];
  backSystemAllList: BackSystemAllList[] = [];
  backSystemCompanyIds: BackSystemCompanyId[] = [];
  onChnageCode: CustomerCodes[] = [];
  @ViewChild('CustCodes', { static: false }) custCode: NgSelectComponent;
  immediateParentForuser: string = "";
  userLimitNumber: number = 0;
  AgencyBranchLimitationRights: boolean;
  ManagersValidation: boolean = false;
  ManagersValidationIndex: number;
  agencyAG01: string = "";
  AgencyBranchChildLimitationRights: boolean;
  parentManagerList: ParentUsers[] = [];
  ParentManagerValidationBool = false;
  creditLimitChecking = new CreditLimitChecking();
  pendingCreditDecreased = false;
  pendingCreditChange: number = 0;
  agencylistid: string = "";
  canAddOrEditAgency: boolean = false;
  backSystemCompanies: CompanyMasterProperties[] = [];
  backSystemCompaniesForAdminInfo: CompanyMasterProperties[] = [];
  agencySuppliers: SupplierRightsForAgencyAndBranchProperties[] = [];
  insuranceSuppliers: SupplierRightsForAgencyAndBranchProperties[] = [];
  backSystemCompanyDisabeld: boolean = false;
  selectMultipleBackSystemCustomer: boolean = false;
  backsystemParentCompanies = new ParentBackSystemCompanies();
  //backSystemCompanies: CompanyMasterProperties[] = [];
  backSystemCompanyId: number;
  backSystemCompanyCustomer: string;
  backSystemCreditRequest = new BackSystemCreditRequest();
  backSystemCreditLimit = new BackSystemCreditLimitProperties();
  stepNine = false;
  revenueRightsComplete = false;
  registerBecomePartner = new RegisterUserProperties();
  ngOnInit() {
    this.CheckCanEditRevenueRights();
    
    this.agencylistid = (localStorage.getItem("AgencyListId"));
    if (localStorage.getItem("ResgisterBecomePartner") != null) {
      const data = localStorage.getItem("ResgisterBecomePartner");
      if (data) {
        console.log('before convert json:', data);
        this.registerBecomePartner = JSON.parse(data);
        this.agencyObj.agencyName = this.registerBecomePartner.companyName;
        this.agencyObj.emailAddress = this.registerBecomePartner.email;
        this.agencyObj.notificationEmail = this.registerBecomePartner.email;
        this.agencyObj.address1 = this.registerBecomePartner.address;
        this.agencyObj.country = this.registerBecomePartner.country;
        this.agencyObj.city = this.registerBecomePartner.city;
        this.agencyObj.mobileContact = this.registerBecomePartner.mobileNo;
        localStorage.removeItem("ResgisterBecomePartner");
      }
      
    }
    
    this.getReportTypes();
    this.AddManager();
    this.GetAgencyBaseData();
    this.imageSource = 'assets/img/Group 430.svg';
    this.getCountries();
    this.agencyAG01 = localStorage.getItem("AgencyId")
    this.GetBackSystemCompanies();
    this.backSystemCreditLimit = this.GetLoginBackSystemCredit();

  }
  GetBackSystemCompanies() {
    this.agencyService.GetCompanyMaster().subscribe(data => {
      this.backSystemCompanies = data;

    })

  }
  GetChildAgencyRight(agencyId) {
    this.agencyService.AgencyBranchChildLimitationRights(agencyId).subscribe((data) => {
      this.AgencyBranchChildLimitationRights = data;
    });

  }
  GetParentManagers(param, agencyId) {
    let isAgency: Boolean = false;
    this.agencyService.GetUsersByParent(param, isAgency, agencyId).subscribe((data) => {
      this.parentManagerList = data
      // console.log(this.parentManagerList);
    })
  }
  ParentManagerValidation() {
    if (this.agencyObj.agencyId != "AG01") {
      if (this.parentManagerList.length > 0) {
        for (let i = 0; i < this.parentManagerList.length; i++) {
          for (let j = 0; j < this.managerList.length; j++) {
            if (this.managerList[j].userId == this.parentManagerList[i].userId) {
              this.ParentManagerValidationBool = true;
              break;
            }
            else {
              this.ParentManagerValidationBool = false;
            }

          }
          if (this.ParentManagerValidationBool) {
            break;
          }
        }
      }

    }
    else {
      this.ParentManagerValidationBool = true;
    }
    return this.ParentManagerValidationBool
  }

  getCountries() {
    try {
      this.agencyService.getCountries().subscribe((data) => {
        this.countryList = data;

      });
    }
    catch (e) {
      console.log(e);
    }
  }
  ReportsagncyCheckboxChange(event) {
    try {
      if (event.target.checked) {
        for (let i = 0; this.reportTypesAgency.length; i++) {
          this.reportTypesAgency[i].status = true;
        }

      }
      else {
        for (let i = 0; this.reportTypesAgency.length; i++) {
          this.reportTypesAgency[i].status = false;
        }

      }
    }
    catch (e) {

    }
  }
  // This method is used to check the rights of user for edit or add the agency management and those who have this right will be able to edit or add the agencies;
  CheckCanEditRevenueRights() {
    this.agencyService.CanEditAgenciesRight().subscribe((data) => {
      this.canAddOrEditAgency = data;
    });
  }
  getReportTypes() {
    this.agencyService.GetAllReportTypes().subscribe((data) => {
      this.reportTypesAgency = data;
      let array = [];
      array = data;
      this.reportTypesUser = JSON.parse(JSON.stringify(array));
    })
  }
  ReportsCheckboxChange(event) {
    try {
      if (event.target.checked) {
        for (let i = 0; this.reportTypesUser.length; i++) {
          this.reportTypesUser[i].status = true;
        }
      }
      else {
        for (let i = 0; this.reportTypesUser.length; i++) {
          this.reportTypesUser[i].status = false;
        }

      }
    }
    catch (e) {

    }

  }

  GetAgencyBaseData() {
    try {

      //---------------------------------- This Section Is Just Updated To Test Parent Baranch Data ------------------------------//
      // 25-05-23 changes Commenet for Testing...............
      // let agencyId = "", loginAgency = "", treeBranchParent, treeSelectedValue = "";
      //end

      this.agencyService.GetBackSystemCustomers().subscribe((data) => {
        if (data.length > 0 && data != null) {
          for (let i = 0; i < data.length; i++) {
            data[i].customerName = data[i].customerCode + " - " + data[i].customerName;
          }
        }
        this.customerCodeList$ = of(data);
      });

      //25-05-23 changes  new Updated For Testing...........
      let agencyId = "", loginAgency = "", branchParent, immediateBranchParent = "";


      if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("AgencyId") != "")) {
        branchParent = localStorage.getItem("AgencyId");
        if (branchParent.includes("B")) {
          immediateBranchParent = localStorage.getItem("ImmediateParent")
          this.agencyService.GetParentChildBranches(immediateBranchParent).subscribe((result) => {
            // console.log(result)
            this.branchCodeList$ = of(result);
            if (result.length > 0) {
              let bId = "";
              for (let i = 0; i < result.length; i++) {
                bId = result[0].branchId;
                // 25-05-23 changes new procedure Also Created GetAgencyBaseDataForBranch
                this.agencyService.GetAgencyBaseDataForBranch(bId).subscribe((result) => {
                  this.agencyCodeList$ = of(result);

                });

              }
            }
          });
        }
        //end


        //25-05-23 changes .......Old Commented  for testing
        //treeSelectedValue = localStorage.getItem("TreeSelectedValue");
        //if (treeSelectedValue != undefined && treeSelectedValue != "" && treeSelectedValue != null) {
        //  treeBranchParent = localStorage.getItem("TreeBranchParent");
        //  if (treeBranchParent != "" && treeBranchParent != null && treeBranchParent != undefined) {
        //    loginAgency = treeBranchParent;
        //    this.agencyObj.immediateParent = treeSelectedValue;
        //    this.agencyObj.parentAgency = treeBranchParent;

        //    this.agencyService.GetParentChildBranches(this.agencyObj.parentAgency).subscribe((data) => {
        //      if (data.some(e => e.branchId === treeSelectedValue)) {
        //        this.branchCodeList$ = of(data);
        //      }
        //      else {
        //        this.agencyService.GetParentChildBranches(this.agencyObj.immediateParent).subscribe((result) => {
        //          this.branchCodeList$ = of(result);
        //        });
        //      }
        //    })
        //  }

        //  else {
        //    loginAgency = treeSelectedValue;
        //    this.agencyObj.parentAgency = treeSelectedValue;
        //  }
        //}
        //  else if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("AgencyId") != ""))

        //---------------------------------- Section End ------------------------------//
        loginAgency = localStorage.getItem("AgencyId");
        localStorage.removeItem("TreeSelectedValue");
        localStorage.removeItem("TreeBranchParent");
        this.agencyService.GetBaseDataForAgencyMaster(loginAgency).subscribe((data) => {

          this.allBaseData$ = data;
          this.agencyCodeList$ = of(this.allBaseData$.agencies);
          this.languageCodeList$ = of(this.allBaseData$.languages);
          this.currencyCodeList$ = of(this.allBaseData$.currencies);
          this.agencyTypeList$ = of(this.allBaseData$.agencyTypes);
          this.agencyGroupList$ = of(this.allBaseData$.agencyGroups);


          if ((localStorage.getItem("AgencyListId") != undefined) && (localStorage.getItem("AgencyListId") != "")) {
            agencyId = (localStorage.getItem("AgencyListId"));
            localStorage.removeItem("AgencyListId");
            this.agencyService.GetAgencyById(agencyId).subscribe((data) => {
              this.immediateParentForuser = "";
              this.immediateParentForuser = data.immediateParent;
              this.pendingCreditChange = data.creditLimit;
              this.agencyObj = data;

              this.GetChildAgencyRight(this.agencyObj.parentAgency)
              this.userLimitNumber = this.agencyObj.maximumUsers;
              this.reportRights = this.agencyObj.agencyRightObj.reportRights;
              for (let i = 0; i < this.reportRights.length; i++) {
                for (let j = 0; j < this.reportTypesAgency.length; j++) {
                  if (this.reportRights[i].reportTypeName == this.reportTypesAgency[j].reportTypes) {
                    this.reportTypesAgency[j].status = this.reportRights[i].status;
                    this.reportTypesAgency[j].reportRightId = this.reportRights[i].reportAgencyRightId;

                  }

                }
              }
              if (this.agencyObj != undefined && this.agencyObj != null) {
                if (this.agencyObj.backCompanyId != null && this.agencyObj.backCompanyId != undefined && this.agencyObj.backCompanyId > 0) {
                  this.backSystemCompanyDisabeld = true;
                }
                else {
                  this.backSystemCompanyDisabeld = false;
                }
                this.agencyBlock = true;
                this.immediateParentBlock = true;
                if ((this.agencyObj.userObj.firstName == null &&
                  this.agencyObj.userObj.lastName == null) ||
                  this.agencyObj.userObj.loginName == null) {

                  this.agencyObj.userObj = new UsersProperties();
                }

                if (this.agencyObj.managers.length > 0)
                  this.managerList = this.agencyObj.managers;
                if (this.agencyObj.settlementMode == 1) {
                  this.settelementCash = true;
                  this.creditReadOnly = true;
                }
                else if (this.agencyObj.settlementMode == 2) {
                  this.settelementCredit = true;
                  this.creditReadOnly = false;
                }
                else {
                  this.settelementCash = false;
                  this.settelementCredit = false;
                  this.creditReadOnly = true;

                }
                if (this.agencyObj.imageFile != "" && this.agencyObj.imageFile != null) {
                  this.imageSource = 'data:image/jpg;base64,' + this.agencyObj.imageFile;
                  this.checkImgUpload = true;
                }
                else {
                  this.imageSource = 'assets/img/Group 430.svg';
                  this.checkImgUpload = false;
                }
                this.agencyObj.language = this.agencyObj.language;
                if (this.agencyObj.agencyColourCode != "" && this.agencyObj.agencyColourCode != null) {
                  this.agencyColor = this.agencyObj.agencyColourCode;
                  var split = this.agencyObj.agencyColourCode.split(",");
                  var split1 = split[0];
                  var split2 = split1.split("(")
                  var split3 = split2[1]
                  document.documentElement.style.setProperty('--hue-color', split3);
                  var buttonValue = Number(split3);
                  if ((buttonValue >= 0 && buttonValue <= 30) || (buttonValue >= 60 && buttonValue <= 90)
                    || (buttonValue >= 120 && buttonValue <= 150) || (buttonValue >= 190 && buttonValue <= 360))
                    document.documentElement.style.setProperty('--button_color', 'white')
                  else {
                    document.documentElement.style.setProperty('--button_color', 'black')
                  }
                }
              }


            });
          }
        });
      }
    } catch (e) {
      console.log(e);
    }


  }

  validateEmail(email) {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
  }
  validateMobileNumber(number) {
    // const regularExp = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
    const regularExp = /\+[0-9]+/;

    return regularExp.test(String(number));
  }

  validateNumber(number) {
    const regularExp = /[0-9]+/;
    return regularExp.test(String(number));
  }
  CheckSettlementValidations(): boolean {
    try {
      if (this.settelementCash == false && this.settelementCredit == false) {
        // this.stepFive = false;
        $("#lblerror").show();
        document.getElementById("lblerror").innerHTML = "Please Enter Required Fields."
        $("#lblerror").delay(3000).hide(10);
        return false;
      }

      else {
        this.stepFive = true;
        return true;
      }
    }

    catch (e) {
      console.log(e);
    }
  }



  CheckChildAgenciesLimit(): Observable<boolean> {
    try {
      let flag = false;
      var subject = new Subject<boolean>();
      let param = "";
      let isAgency;
      if (this.agencyObj.immediateParent == "" || this.agencyObj.immediateParent == null
        || this.agencyObj.immediateParent == this.agencyObj.parentAgency) {
        isAgency = true;
      }
      else
        isAgency = false;
      if (isAgency == true)
        param = this.agencyObj.parentAgency;
      else
        param = this.agencyObj.immediateParent;
      this.agencyService.CheckChildAgenciesLimit(param, isAgency).subscribe((data) => {
        if (data != null && data != undefined) {
          if (data == -1) {
            flag = false;
            subject.next(flag);
            $("#lblerrormsg").show();
            document.getElementById("lblerrormsg").innerHTML = "Maximum Agency Limit Reached."
            $("#lblerrormsg").delay(5000).hide(10);
          }
          else {
            flag = true;
            subject.next(flag);
          }
        }
        else {
          flag = false;
          subject.next(flag);
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
          $("#lblerrormsg").delay(5000).hide(10);
        }
      });
      return subject.asObservable();

    }
    catch (e) {
      console.log(e);
    }
  }
  CloseInformation() {
    this.router.navigateByUrl('/agencyList');
  }

  contactInfoBackClick() {
    this.BackOfficeInfoComplete = false;
    this.agencyInfoComplete = true;
    this.stepTwo = false;
  }
  managerInfoBackClick() {
    this.managerInfoComplete = false;
    this.stepFive = false;
    this.adminInfoComplete = true;
  }
  adminInfoBackClick() {

    this.adminInfoComplete = false;
    this.agencyRightsComplete = true;
    this.stepFour = false;
  }
  settleModeBackClick() {
    this.settleModeComplete = false;
    this.agencyRightsComplete = true;
    this.stepFive = false;
  }
  logoInfoBackClick() {
    this.logoInfoComplete = false;
    this.settleModeComplete = true;
    this.stepSix = false;
    this.stepNine = false;
  }
  AgencyRightsBackClick = (): void => {
    this.backsystemOfficeProperties = [];
    this.backsystemgetinfo(this.agencyObj.agencyId);

    if (this.agencyAG01 == "AG01") {
      this.agencyRightsComplete = false;
      this.BackOfficeInfoComplete = true;
      this.stepThree = false;
    }
    else {
      this.agencyInfoComplete = true;
      this.stepOne = true;
      this.BackOfficeInfoComplete = false;
      this.stepTwo = false;
      this.agencyRightsComplete = false;
      this.stepThree = false;
    }

  }

  SupplierRightsBackClick() {
    this.supplierRightsComplete = false;
    this.managerInfoComplete = true;
    this.stepSix = false;
  }

  RadioSettleMentCheck(e) {
    try {
      if (e.target.value == "Cash") {
        var cash = document.querySelector("#tbCredit") as HTMLInputElement;
        cash.value = String(0);
        this.settelementCash = true;
        this.settelementCredit = false;
        this.agencyObj.settlementMode = 1;
        this.creditReadOnly = true;
        this.agencyObj.creditLimit = 0;
        this.creditCheck = false;

        this.pendingCreditDecreased = false;
      }
      else if (e.target.value == "Credit") {
        var credit = document.querySelector("#tbCredit") as HTMLInputElement;
        credit.value = String(this.agencyObj.creditLimit);
        this.settelementCredit = true;
        this.settelementCash = false;
        this.agencyObj.settlementMode = 2;
        this.creditReadOnly = false;
      }
    }
    catch (e) {

    }
  }
  UserRoleAdministrator(event) {
    if (event.target.checked) {
      this.agencyObj.userObj.userRoleId = 1;
    }
    else {
      this.agencyObj.userObj.userRoleId = 0;
    }
  }
  UserRoleChange(event) {

    if (this.agencyObj.userObj.isAgencyAdmin == true)
      this.agencyObj.userObj.userRoleId = 1;
    else if (this.agencyObj.userObj.isAgent == true)
      this.agencyObj.userObj.userRoleId = 2;
    if (this.agencyObj.userObj.isAgencyAdmin == true && this.agencyObj.userObj.isAgent == true)
      this.agencyObj.userObj.userRoleId = 1;
    else if (this.agencyObj.userObj.isAgencyAdmin == false && this.agencyObj.userObj.isAgent == false)
      this.agencyObj.userObj.userRoleId = 0;
  }

  AdministratorCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.agencyObj.userObj.adminUser.profileUpdate = true;
        this.agencyObj.userObj.adminUser.beneficiaryAccount = true;
        this.agencyObj.userObj.adminUser.paymentProcess = true;
        this.agencyObj.userObj.adminUser.creditLimit = true;
        this.agencyObj.userObj.adminUser.notifications = true;
        this.agencyObj.userObj.adminUser.revenueManagement = true;
        this.agencyObj.userObj.adminUser.offlineRequest = true;
        this.agencyObj.userObj.adminUser.offlineSettings = true;
        this.agencyObj.userObj.adminUser.supplierManagement = true;
        this.agencyObj.userObj.adminUser.accountManagement = true;
        this.agencyObj.userObj.adminUser.bookings = true;
        this.agencyObj.userObj.adminUser.cms = true;
        this.agencyObj.userObj.adminUser.reports = true;
        this.agencyObj.userObj.adminUser.dashboard = true;
      }
      else {
        this.agencyObj.userObj.adminUser.profileUpdate = false;
        this.agencyObj.userObj.adminUser.beneficiaryAccount = false;
        this.agencyObj.userObj.adminUser.paymentProcess = false;
        this.agencyObj.userObj.adminUser.creditLimit = false;
        this.agencyObj.userObj.adminUser.notifications = false;
        this.agencyObj.userObj.adminUser.revenueManagement = false;
        this.agencyObj.userObj.adminUser.offlineRequest = false;
        this.agencyObj.userObj.adminUser.offlineSettings = false;
        this.agencyObj.userObj.adminUser.supplierManagement = false;
        this.agencyObj.userObj.adminUser.accountManagement = false;
        this.agencyObj.userObj.adminUser.bookings = false;
        this.agencyObj.userObj.adminUser.cms = false;
        this.agencyObj.userObj.adminUser.reports = false;
        this.agencyObj.userObj.adminUser.dashboard = false;
      }

    }
    catch (e) {
    }
  }

  AdminCheckboxChange(ev) {

    try {
      if (ev.target.checked) {
        this.agencyObj.agencyRightObj.profileUpdate = true;
        this.agencyObj.agencyRightObj.beneficiaryAccount = true;
        this.agencyObj.agencyRightObj.paymentProcess = true;
        this.agencyObj.agencyRightObj.creditLimit = true;
        this.agencyObj.agencyRightObj.notifications = true;
        this.agencyObj.agencyRightObj.revenueManagement = true;
        this.agencyObj.agencyRightObj.offlineRequest = true;
        this.agencyObj.agencyRightObj.offlineSettings = true;
        this.agencyObj.agencyRightObj.supplierManagement = true;
        this.agencyObj.agencyRightObj.accountManagement = true;
        this.agencyObj.agencyRightObj.bookings = true;
        this.agencyObj.agencyRightObj.cms = true;
        this.agencyObj.agencyRightObj.reports = true;
        this.agencyObj.agencyRightObj.dashboard = true;
        this.agencyObj.agencyRightObj.reportsManagement = true;
      }
      else {
        this.agencyObj.agencyRightObj.profileUpdate = false;
        this.agencyObj.agencyRightObj.beneficiaryAccount = false;
        this.agencyObj.agencyRightObj.paymentProcess = false;
        this.agencyObj.agencyRightObj.creditLimit = false;
        this.agencyObj.agencyRightObj.notifications = false;
        this.agencyObj.agencyRightObj.revenueManagement = false;
        this.agencyObj.agencyRightObj.offlineRequest = false;
        this.agencyObj.agencyRightObj.offlineSettings = false;
        this.agencyObj.agencyRightObj.supplierManagement = false;
        this.agencyObj.agencyRightObj.accountManagement = false;
        this.agencyObj.agencyRightObj.bookings = false;
        this.agencyObj.agencyRightObj.cms = false;
        this.agencyObj.agencyRightObj.reports = false;
        this.agencyObj.agencyRightObj.dashboard = false;
        this.agencyObj.agencyRightObj.reportsManagement = false;
      }

    }
    catch (e) {
    }



  }




  PaymentUserCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.agencyObj.userObj.adminUser.addPayment = true;
        this.agencyObj.userObj.adminUser.approvePayment = true;
        this.agencyObj.userObj.adminUser.deletePayment = true;
      }
      else {
        this.agencyObj.userObj.adminUser.addPayment = false;
        this.agencyObj.userObj.adminUser.approvePayment = false;
        this.agencyObj.userObj.adminUser.deletePayment = false;
      }
    }
    catch (e) {

    }
  }

  PaymentCheckboxChange(eve) {

    try {
      if (eve.target.checked) {
        this.agencyObj.agencyRightObj.addPayment = true;
        this.agencyObj.agencyRightObj.approvePayment = true;
        this.agencyObj.agencyRightObj.deletePayment = true;
      }
      else {
        this.agencyObj.agencyRightObj.addPayment = false;
        this.agencyObj.agencyRightObj.approvePayment = false;
        this.agencyObj.agencyRightObj.deletePayment = false;
      }
    }
    catch (e) {

    }
  }

  OfflineCheckboxChange(ev) {

    try {

      if (ev.target.checked) {
        this.agencyObj.agencyRightObj.offlineBooking = true;
        this.agencyObj.agencyRightObj.offlineTicket = true;
        this.agencyObj.agencyRightObj.offlineRefund = true;
        this.agencyObj.agencyRightObj.offlineVoid = true;
        this.agencyObj.agencyRightObj.offlineDealsByCMS = true;

      } else {
        this.agencyObj.agencyRightObj.offlineBooking = false;
        this.agencyObj.agencyRightObj.offlineTicket = false;
        this.agencyObj.agencyRightObj.offlineRefund = false;
        this.agencyObj.agencyRightObj.offlineVoid = false;
        this.agencyObj.agencyRightObj.offlineDealsByCMS = false;

      }

    } catch (e) { }

  }

  OfflineUserCheckboxChange(ev) {

    try {

      if (ev.target.checked) {
        this.agencyObj.userObj.adminUser.offlineBooking = true;
        this.agencyObj.userObj.adminUser.offlineTicket = true;
        this.agencyObj.userObj.adminUser.offlineRefund = true;
        this.agencyObj.userObj.adminUser.offlineVoid = true;
        this.agencyObj.userObj.adminUser.offlineDealsByCMS = true;

      } else {
        this.agencyObj.userObj.adminUser.offlineBooking = false;
        this.agencyObj.userObj.adminUser.offlineTicket = false;
        this.agencyObj.userObj.adminUser.offlineRefund = false;
        this.agencyObj.userObj.adminUser.offlineVoid = false;
        this.agencyObj.userObj.adminUser.offlineDealsByCMS = false;

      }

    } catch (e) { }


  }


  AccountUserCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.agencyObj.userObj.adminUser.account = true;
        this.agencyObj.userObj.adminUser.users = true;
        this.agencyObj.userObj.adminUser.agencyManagement = true;
        this.agencyObj.userObj.adminUser.branchManagement = true;
        this.agencyObj.userObj.adminUser.logs = true;
        this.agencyObj.userObj.adminUser.currency = true;
      }
      else {
        this.agencyObj.userObj.adminUser.account = false;
        this.agencyObj.userObj.adminUser.users = false;
        this.agencyObj.userObj.adminUser.agencyManagement = false;
        this.agencyObj.userObj.adminUser.branchManagement = false;
        this.agencyObj.userObj.adminUser.logs = false;
        this.agencyObj.userObj.adminUser.currency = false;
      }
    }
    catch (e) {

    }
  }

  AccountCheckboxChange(eve) {
    try {
      if (eve.target.checked) {
        this.agencyObj.agencyRightObj.account = true;
        this.agencyObj.agencyRightObj.users = true;
        this.agencyObj.agencyRightObj.agencyManagement = true;
        this.agencyObj.agencyRightObj.branchManagement = true;
        this.agencyObj.agencyRightObj.logs = true;
        this.agencyObj.agencyRightObj.currency = true;
      }
      else {
        this.agencyObj.agencyRightObj.account = false;
        this.agencyObj.agencyRightObj.users = false;
        this.agencyObj.agencyRightObj.agencyManagement = false;
        this.agencyObj.agencyRightObj.branchManagement = false;
        this.agencyObj.agencyRightObj.logs = false;
        this.agencyObj.agencyRightObj.currency = false;
      }
    }
    catch (e) {

    }

  }

  BookingCheckboxChange(eve) {
    try {
      if (eve.target.checked) {
        this.agencyObj.agencyRightObj.searchBookings = true;
        this.agencyObj.agencyRightObj.viewBookings = true;
        this.agencyObj.agencyRightObj.updateBookings = true;
        this.agencyObj.agencyRightObj.viewSubAgentBookings = true;
        this.agencyObj.agencyRightObj.issueTicket = true;
        this.agencyObj.agencyRightObj.cancelPNR = true;
        this.agencyObj.agencyRightObj.refund = true;
        this.agencyObj.agencyRightObj.importPNR = true;
        this.agencyObj.agencyRightObj.exchange = true;
        this.agencyObj.agencyRightObj.quotations = true;
        this.agencyObj.agencyRightObj.fareRulesResult = true;
        this.agencyObj.agencyRightObj.voidTicket = true;
      }
      else {
        this.agencyObj.agencyRightObj.searchBookings = false;
        this.agencyObj.agencyRightObj.viewBookings = false;
        this.agencyObj.agencyRightObj.updateBookings = false;
        this.agencyObj.agencyRightObj.viewSubAgentBookings = false;
        this.agencyObj.agencyRightObj.issueTicket = false;
        this.agencyObj.agencyRightObj.cancelPNR = false;
        this.agencyObj.agencyRightObj.refund = false;
        this.agencyObj.agencyRightObj.importPNR = false;
        this.agencyObj.agencyRightObj.exchange = false;
        this.agencyObj.agencyRightObj.quotations = false;
        this.agencyObj.agencyRightObj.fareRulesResult = false;
        this.agencyObj.agencyRightObj.voidTicket = false;
      }
    }
    catch (e) {
    }


  }


  BookingUserCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.agencyObj.userObj.adminUser.searchBookings = true;
        this.agencyObj.userObj.adminUser.viewBookings = true;
        this.agencyObj.userObj.adminUser.updateBookings = true;
        this.agencyObj.userObj.adminUser.viewSubAgentBookings = true;
        this.agencyObj.userObj.adminUser.issueTicket = true;
        this.agencyObj.userObj.adminUser.cancelPNR = true;
        this.agencyObj.userObj.adminUser.refund = true;
        this.agencyObj.userObj.adminUser.importPNR = true;
        this.agencyObj.userObj.adminUser.exchangeTicket = true;
        this.agencyObj.userObj.adminUser.quotations = true;
        this.agencyObj.userObj.adminUser.fareRules = true;
        this.agencyObj.userObj.adminUser.voidTicket = true;
      }
      else {
        this.agencyObj.userObj.adminUser.searchBookings = false;
        this.agencyObj.userObj.adminUser.viewBookings = false;
        this.agencyObj.userObj.adminUser.updateBookings = false;
        this.agencyObj.userObj.adminUser.viewSubAgentBookings = false;
        this.agencyObj.userObj.adminUser.issueTicket = false;
        this.agencyObj.userObj.adminUser.cancelPNR = false;
        this.agencyObj.userObj.adminUser.refund = false;
        this.agencyObj.userObj.adminUser.importPNR = false;
        this.agencyObj.userObj.adminUser.exchangeTicket = false;
        this.agencyObj.userObj.adminUser.quotations = false;
        this.agencyObj.userObj.adminUser.fareRules = false;
        this.agencyObj.userObj.adminUser.voidTicket = false;
      }
    }
    catch (e) {
    }
  }
  AgentCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.agencyObj.userObj.agentUser.book = true;
        this.agencyObj.userObj.agentUser.issueTicket = true;
        this.agencyObj.userObj.agentUser.issuePNR = true;
        this.agencyObj.userObj.agentUser.cancelTicket = true;
        this.agencyObj.userObj.agentUser.cancelPNR = true;
        this.agencyObj.userObj.agentUser.quotations = true;
        this.agencyObj.userObj.agentUser.voidTicket = true;
        this.agencyObj.userObj.agentUser.fareRules_Result = true;
        this.agencyObj.userObj.agentUser.offlineRequest = true;
        this.agencyObj.userObj.agentUser.offlineBooking = true;
        this.agencyObj.userObj.agentUser.reprice = true;
        this.agencyObj.userObj.agentUser.markup = true;
        this.agencyObj.userObj.agentUser.refund = true;
        this.agencyObj.userObj.agentUser.offlineRefund = true;
        this.agencyObj.userObj.agentUser.exchange = true;
        this.agencyObj.userObj.agentUser.calenderSearch = true;
        this.agencyObj.userObj.agentUser.recentSearch = true;
        this.agencyObj.userObj.agentUser.adminPanelLogin = true;
      }
      else {
        this.agencyObj.userObj.agentUser.book = false;
        this.agencyObj.userObj.agentUser.issueTicket = false;
        this.agencyObj.userObj.agentUser.issuePNR = false;
        this.agencyObj.userObj.agentUser.cancelTicket = false;
        this.agencyObj.userObj.agentUser.cancelPNR = false;
        this.agencyObj.userObj.agentUser.quotations = false;
        this.agencyObj.userObj.agentUser.voidTicket = false;
        this.agencyObj.userObj.agentUser.fareRules_Result = false;
        this.agencyObj.userObj.agentUser.offlineRequest = false;
        this.agencyObj.userObj.agentUser.offlineBooking = false;
        this.agencyObj.userObj.agentUser.reprice = false;
        this.agencyObj.userObj.agentUser.markup = false;
        this.agencyObj.userObj.agentUser.refund = false;
        this.agencyObj.userObj.agentUser.offlineRefund = false;
        this.agencyObj.userObj.agentUser.exchange = false;
        this.agencyObj.userObj.agentUser.calenderSearch = false;
        this.agencyObj.userObj.agentUser.recentSearch = false;
        this.agencyObj.userObj.agentUser.adminPanelLogin = false;
      }
    }
    catch (e) {

    }
  }
  AgentBookingCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.agencyObj.userObj.agentUser.newBookings = true;
        this.agencyObj.userObj.agentUser.myBookings = true;
        this.agencyObj.userObj.agentUser.searchBookings = true;
      }
      else {
        this.agencyObj.userObj.agentUser.newBookings = false;
        this.agencyObj.userObj.agentUser.myBookings = false;
        this.agencyObj.userObj.agentUser.searchBookings = false;
      }
    }
    catch (e) {

    }
  }



  GetUsers() {
    try {

      let param = "";
      let isAgency;
      if (this.agencyObj.immediateParent == "" || this.agencyObj.immediateParent == null
        || this.agencyObj.immediateParent == this.agencyObj.parentAgency) {
        isAgency = true;
      }
      else
        isAgency = false;
      if (isAgency == true)
        param = this.agencyObj.parentAgency;
      else
        param = this.agencyObj.immediateParent;
      this.agencyService.GetUsersByParent(param, isAgency, this.agencyObj.agencyId).subscribe((data) => {
        this.managerUserList$ = of(data);
        this.parentUsertList = data;
      })
    }
    catch (e) { }
  }
  ManagerUserChange(value, index) {
    try {

      if (value != null) {
        for (let i = 0; i < this.parentUsertList.length; i++) {
          if (this.parentUsertList[i].userId == value) {
            this.managerList[index].managerName = this.parentUsertList[i].fullname;
            break;
          }
        }
        for (let j = 0; j < this.managerList.length - 1; j++) {
          if (this.managerList[j].userId == this.managerList[index].userId) {
            document.getElementById("requiredManagerName" + index).innerHTML = "Already Selected! Please Select Other One";
            document.getElementById("managerNameInput" + index).classList.add("newRequired-BoxColor");
            document.getElementById("labelManagerName" + index).style.color = "red";
            document.getElementById("ManagerDetailsBackBtn").style.display = "none";
            this.ManagersValidation = true;
            this.ManagersValidationIndex = index;
            break;
          }
          else {
            document.getElementById("managerNameInput" + index).classList.remove("newRequired-BoxColor");
            document.getElementById("labelManagerName" + index).style.color = "";
            document.getElementById("requiredManagerName" + index).innerHTML = "";
            document.getElementById("ManagerDetailsBackBtn").style.display = "block";
            this.ManagersValidation = false;
          }
        }
      }
      else {
        document.getElementById("managerNameInput" + index).classList.remove("newRequired-BoxColor");
        document.getElementById("labelManagerName" + index).style.color = "";
        document.getElementById("requiredManagerName" + index).innerHTML = "";
        document.getElementById("ManagerDetailsBtn").removeAttribute('disabled');
        document.getElementById("ManagerDetailsBtn").style.background = "";
        document.getElementById("ManagerDetailsBackBtn").style.display = "block";

      }

    }
    catch (e) {

    }
  }
  GetSuppliersByParent() {
    try {

      if (this.agencyObj.immediateParent != "") {
        this.agencyService.GetSuppliersByParent(this.agencyObj.immediateParent).subscribe((data) => {
          this.supplierRightsData = data;
          if (this.supplierRightsData.dataList.length > 0) {
            this.agencySuppliers = [];
            this.insuranceSuppliers = [];
            if (this.agencyObj.agencySupplierList.length > 0) {
              for (let i = 0; i < this.supplierRightsData.dataList.length; i++) {
                let suppliers = new SupplierRightsForAgencyAndBranchProperties();
                suppliers.supplierName = this.supplierRightsData.dataList[i].name;
                suppliers.supplierTypeId = this.supplierRightsData.dataList[i].supplierTypeId;
                suppliers.supplierId = this.supplierRightsData.dataList[i].supplierId;

                for (let j = 0; j < this.agencyObj.agencySupplierList.length; j++) {
                  let agencySuppliersBool = new SupplierRightsForAgencyAndBranchBooleanProperties();
                  if (this.agencyObj.agencySupplierList[j].supplierId == this.supplierRightsData.dataList[i].supplierId) {
                    suppliers.supplierStatus = this.agencyObj.agencySupplierList[j].status;
                    agencySuppliersBool.canBook = this.agencyObj.agencySupplierList[j].canBook;
                    agencySuppliersBool.canIssue = this.agencyObj.agencySupplierList[j].canIssue;
                    agencySuppliersBool.canRefund = this.agencyObj.agencySupplierList[j].canRefund;
                    agencySuppliersBool.canSearch = this.agencyObj.agencySupplierList[j].canSearch;
                    agencySuppliersBool.canVoid = this.agencyObj.agencySupplierList[j].canVoid;
                    agencySuppliersBool.supplierOficeId = this.agencyObj.agencySupplierList[j].supplierOficeId.toString();
                    suppliers.supplierBoolean.push(agencySuppliersBool);

                  }
                }
                for (let k = 0; k < this.supplierRightsData.dataList[i].supplierOficeIdlist.length; k++) {
                  let id = new SuppliersOfficeIds();
                  id.officeIds = this.supplierRightsData.dataList[i].supplierOficeIdlist[k].officeId;
                  suppliers.supplierOfficeIdsCounter += 1;
                  suppliers.suppliersOfficeIds.push(id);
                }

              
                if (suppliers.supplierTypeId == 1) {
                  this.agencySuppliers.push(suppliers);
                }
                else if (suppliers.supplierTypeId == 3) {
                  this.insuranceSuppliers.push(suppliers);
                  }
               

              }

            }
            else {
              for (let i = 0; i < this.supplierRightsData.dataList.length; i++) {
                let suppliers = new SupplierRightsForAgencyAndBranchProperties();
                suppliers.supplierName = this.supplierRightsData.dataList[i].name;
                suppliers.supplierId = this.supplierRightsData.dataList[i].supplierId;
                suppliers.supplierTypeId = this.supplierRightsData.dataList[i].supplierTypeId;
                for (let k = 0; k < this.supplierRightsData.dataList[i].supplierOficeIdlist.length; k++) {
                  let id = new SuppliersOfficeIds();
                  id.officeIds = this.supplierRightsData.dataList[i].supplierOficeIdlist[k].officeId;
                  suppliers.supplierOfficeIdsCounter += 1;
                  suppliers.suppliersOfficeIds.push(id);
                }

                if (suppliers.supplierTypeId == 1) {
                  this.agencySuppliers.push(suppliers);
                }
                else if (suppliers.supplierTypeId == 3) {
                  this.insuranceSuppliers.push(suppliers);
                }

              }

            }
          }

        })
      }
    }
    catch (e) { }
  }

  GetparentAgencyRights() {
    try {
      let param = "";
      let isAgency;
      if (this.agencyObj.immediateParent == "" || this.agencyObj.immediateParent == null
        || this.agencyObj.immediateParent == this.agencyObj.parentAgency) {
        isAgency = true;
      }
      else
        isAgency = false;
      if (isAgency == true)
        param = this.agencyObj.parentAgency;
      else
        param = this.agencyObj.immediateParent;
      if (param != "") {
        this.agencyService.GetparentAgencyRights(param, this.agencyObj.userObj.userId).subscribe((data) => {
          let rightsObj = new AgencyRightsProperties;
          this.userRightDisable = new UserRightsDisabledProperties();
          rightsObj = (data);
          if (rightsObj.reportUserRights != null) {
            for (let i = 0; i < rightsObj.reportUserRights.length; i++) {

              for (let j = 0; j < this.reportTypesUser.length; j++) {
                if (this.reportTypesUser[j].reportTypes == rightsObj.reportUserRights[i].reportTypeName) {

                  this.reportTypesUser[j].reportRightId = rightsObj.reportUserRights[i].reportAgencyRightId;
                  this.reportTypesUser[j].status = rightsObj.reportUserRights[i].status;

                }

              }
            }
          }
          if (rightsObj != null) {
            if (rightsObj.profileUpdate == false) {
              // this.agr_profileDisabled = true;
              this.userRightDisable.ad_profileDisbled = true;
              this.agencyObj.userObj.adminUser.profileUpdate = false;
            } else {
              this.userRightDisable.ad_profileDisbled = false;
            }
            if (rightsObj.beneficiaryAccount == false) {
              // this.agr_BeneficiaryDisabled = true;
              this.userRightDisable.ad_beneficiaryDisabled = true;
              this.agencyObj.userObj.adminUser.beneficiaryAccount = false;
            } else {
              this.userRightDisable.ad_beneficiaryDisabled = false;
            }

            if (rightsObj.paymentProcess == false) {
              // this.agr_PaymentDisabled = true;
              this.userRightDisable.ad_paymentProcessDisabled = true;
              this.agencyObj.userObj.adminUser.paymentProcess = false;
            } else {
              this.userRightDisable.ad_paymentProcessDisabled = false;
            }

            if (rightsObj.creditLimit == false) {
              //  this.agr_CreditDisabled = true;
              this.userRightDisable.ad_creditLimitDisabled = true;
              this.agencyObj.userObj.adminUser.creditLimit = false;
            } else {
              this.userRightDisable.ad_creditLimitDisabled = false;
            }

            if (rightsObj.notifications == false) {
              //  this.agr_NoticationsDisabled = true;
              this.userRightDisable.ad_notificationsDisabled = true;
              this.agencyObj.userObj.adminUser.notifications = false;
            } else {
              this.userRightDisable.ad_notificationsDisabled = false;
            }

            if (rightsObj.revenueManagement == false) {
              // this.agr_ServiceFeeDisabled = true;
              this.userRightDisable.ad_revenueDisabled = true;
              this.agencyObj.userObj.adminUser.revenueManagement = false;
            } else {
              // this.agr_ServiceFeeDisabled = true;
              this.userRightDisable.ad_revenueDisabled = false;
            }

            if (rightsObj.offlineRequest == false) {
              //  this.agr_OfflineRequestDisabled = true;
              this.userRightDisable.ad_offlineRequestDisabled = true;
              this.agencyObj.userObj.adminUser.offlineRequest = false;
            } else {
              //  this.agr_OfflineRequestDisabled = true;
              this.userRightDisable.ad_offlineRequestDisabled = false;
            }

            if (rightsObj.offlineSettings == false) {
              // this.agr_OfflineSettingsDisabled = true;
              this.userRightDisable.ad_offlineSettingsDisabled = true;
              this.agencyObj.userObj.adminUser.offlineSettings = false;
            } else {
              // this.agr_OfflineSettingsDisabled = true;
              this.userRightDisable.ad_offlineSettingsDisabled = false;
            }

            if (rightsObj.supplierManagement == false) {
              // this.supplierStep = false;
              // this.agr_SupplierDisabled = true;
              this.userRightDisable.ad_supplierManagementDisabled = true;
              this.agencyObj.userObj.adminUser.supplierManagement = false;
              //  $("#btnAdminCancel").show();
              //  $("#btnAdminSave").html("Save");
            }
            else {
              // this.supplierStep = true;
              //   $("#btnAdminCancel").hide();
              //   $("#btnAdminSave").html("Next Step");

            }
            if (rightsObj.accountManagement == false) {

              //  this.agr_AccountManagementDisabled = true;
              this.userRightDisable.ad_accountManagementDisabled = true;
              this.agencyObj.userObj.adminUser.accountManagement = false;
            } else {
              //  this.agr_AccountManagementDisabled = true;
              this.userRightDisable.ad_accountManagementDisabled = false;
            }

            if (rightsObj.bookings == false) {
              //  this.agr_BookingsDisabled = true;
              this.userRightDisable.ad_bookingsDisabled = true;
              this.agencyObj.userObj.adminUser.bookings = false;
            } else {
              //  this.agr_BookingsDisabled = true;
              this.userRightDisable.ad_bookingsDisabled = false;
            }

            if (rightsObj.cms == false) {
              //  this.agr_CmsDisabled = true;
              this.userRightDisable.ad_cmsDisabled = true;
              this.agencyObj.userObj.adminUser.cms = false;
            } else {
              //  this.agr_CmsDisabled = true;
              this.userRightDisable.ad_cmsDisabled = false;
            }

            if (rightsObj.reports == false) {
              //  this.agr_ReportsDisabled = true;
              this.userRightDisable.ad_reportsDisabled = true;
              this.agencyObj.userObj.adminUser.reports = false;
            } else {
              //  this.agr_ReportsDisabled = true;
              this.userRightDisable.ad_reportsDisabled = false;
            }

            if (rightsObj.dashboard == false) {
              //  this.agr_DashboardDisabled = true;
              this.userRightDisable.ad_dashboardDisabled = true;
              this.agencyObj.userObj.adminUser.dashboard = false;
            } else {
              //  this.agr_DashboardDisabled = true;
              this.userRightDisable.ad_dashboardDisabled = false;
            }

            if (rightsObj.addPayment == false) {
              //  this.agr_AddPaymentDisabled = true;
              this.userRightDisable.ad_addPaymentDisabled = true;
              this.agencyObj.userObj.adminUser.addPayment = false;
            } else {
              //  this.agr_AddPaymentDisabled = true;
              this.userRightDisable.ad_addPaymentDisabled = false;
            }

            if (rightsObj.approvePayment == false) {
              //  this.agr_ApprovePaymentDisabled = true;
              this.userRightDisable.ad_approvePaymentDisabled = true;
              this.agencyObj.userObj.adminUser.approvePayment = false;
            } else {
              //  this.agr_ApprovePaymentDisabled = true;
              this.userRightDisable.ad_approvePaymentDisabled = false;
            }

            if (rightsObj.deletePayment == false) {
              //  this.agr_DeletePaymentDisabled = true;
              this.userRightDisable.ad_deletePaymentDisabled = true;
              this.agencyObj.userObj.adminUser.deletePayment = false;
            } else {
              //  this.agr_DeletePaymentDisabled = true;
              this.userRightDisable.ad_deletePaymentDisabled = false;
            }

            if (rightsObj.account == false) {
              //  this.agr_AccountDisabled = true;
              this.userRightDisable.ad_accountDisabled = true;
              this.agencyObj.userObj.adminUser.account = false;
            } else {
              //  this.agr_AccountDisabled = true;
              this.userRightDisable.ad_accountDisabled = false;
            }

            if (rightsObj.users == false) {
              //   this.agr_UsersDisabled = true;
              this.userRightDisable.ad_usersDisabled = true;
              this.agencyObj.userObj.adminUser.users = false;
            } else {
              //   this.agr_UsersDisabled = true;
              this.userRightDisable.ad_usersDisabled = false;
            }

            if (rightsObj.logs == false) {
              //   this.agr_LogsDisabled = true;
              this.userRightDisable.ad_logsDisabled = true;
              this.agencyObj.userObj.adminUser.logs = false;
            } else {
              //   this.agr_LogsDisabled = true;
              this.userRightDisable.ad_logsDisabled = false;
            }

            if (rightsObj.currency == false) {
              //  this.agr_CurrencyDisabled = true;
              this.userRightDisable.ad_currencyDisabled = true;
              this.agencyObj.userObj.adminUser.currency = false;
            } else {
              //  this.agr_CurrencyDisabled = true;
              this.userRightDisable.ad_currencyDisabled = false;
            }

            if (rightsObj.searchBookings == false) {
              //  this.agr_SearchBookingsDisabled = true;
              this.userRightDisable.ad_searchBookingsDisabled = true;
              this.agencyObj.userObj.adminUser.searchBookings = false;
            } else {
              //  this.agr_SearchBookingsDisabled = true;
              this.userRightDisable.ad_searchBookingsDisabled = false;
            }

            if (rightsObj.viewBookings == false) {
              //  this.agr_ViewBookingsDisabled = true;
              this.userRightDisable.ad_viewBookingsDisabled = true;
              this.agencyObj.userObj.adminUser.viewBookings = false;
            } else {
              //  this.agr_ViewBookingsDisabled = true;
              this.userRightDisable.ad_viewBookingsDisabled = false;
            }

            if (rightsObj.updateBookings == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ad_updateBookingsDisabled = true;
              this.agencyObj.userObj.adminUser.updateBookings = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ad_updateBookingsDisabled = false;
            }


            if (rightsObj.offlineBooking == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineBookingsDisabled = true;
              this.agencyObj.userObj.adminUser.offlineBooking = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineBookingsDisabled = false;
            }

            if (rightsObj.offlineTicket == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineTicketDisabled = true;
              this.agencyObj.userObj.adminUser.offlineTicket = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineTicketDisabled = false;
            }

            if (rightsObj.offlineVoid == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineVoidDisabled = true;
              this.agencyObj.userObj.adminUser.offlineVoid = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineVoidDisabled = false;
            }

            if (rightsObj.offlineRefund == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineRefundDisabled = true;
              this.agencyObj.userObj.adminUser.offlineRefund = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineRefundDisabled = false;
            }

            if (rightsObj.offlineDealsByCMS == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineDealsDisabled = true;
              this.agencyObj.userObj.adminUser.offlineDealsByCMS = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineDealsDisabled = false;
            }

            if (rightsObj.offlineManage == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineManage = true;
              this.agencyObj.userObj.adminUser.offlineManage = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineManage = false;
            }
            if (rightsObj.offlineManageBooking == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineManageBooking = true;
              this.agencyObj.userObj.adminUser.offlineManageBooking = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineManageBooking = false;
            }
            if (rightsObj.offlineManageTicket == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineManageTicket = true;
              this.agencyObj.userObj.adminUser.offlineManageTicket = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineManageTicket = false;
            }
            if (rightsObj.offlineManageVoid == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineManageVoid = true;
              this.agencyObj.userObj.adminUser.offlineManageVoid = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineManageVoid = false;
            }
            if (rightsObj.offlineManageRefund == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineManageRefund = true;
              this.agencyObj.userObj.adminUser.offlineManageRefund = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineManageRefund = false;
            }
            if (rightsObj.offlineManageResissue == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineManageResissue = true;
              this.agencyObj.userObj.adminUser.offlineManageResissue = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineManageResissue = false;
            }

          }

        })
      }
    }
    catch (e) { }
  }
  AgencyInfoValidations(): boolean {
    if (this.agencyObj.agencyId != "AG01") {
      try {

        if (this.agencyObj.parentAgency == "" || this.agencyObj.agencyName == "" || this.agencyObj.emailAddress == ""
          || this.agencyObj.notificationEmail == "") {

          // this.stepTwo = false;
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Please Enter Required* Fields."
          $("#lblerrormsg").delay(5000).hide(10);
          return false;
        }
        if (!this.validateEmail(this.agencyObj.emailAddress)) {
          // this.emailValid.focus();
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Email Pattern Must Be True"
          $("#lblerrormsg").delay(4000).hide(10);
          return false;
        }

        else {
          // this.stepTwo = true;
          return true;
        }

      }

      catch (e) {
        console.log(e);
      }
    }
    else if (this.agencyObj.agencyId == "AG01") {
      try {
        if (this.agencyObj.agencyName == "" || this.agencyObj.emailAddress == ""
          || this.agencyObj.notificationEmail == "") {

          // this.stepTwo = false;
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Please Enter Required* Fields."
          $("#lblerrormsg").delay(5000).hide(10);
          return false;
        }
        if (!this.validateEmail(this.agencyObj.emailAddress)) {
          // this.emailValid.focus();
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Email Pattern Must Be True"
          $("#lblerrormsg").delay(4000).hide(10);
          return false;
        }

        else {
          // this.stepTwo = true;
          return true;
        }

      } catch (ex) {
        console.log(ex);
      }
    }
  }

  SaveSupplierRights = (req: string): boolean => {
    try {
      if (Number(localStorage.getItem("UserId")) != 0 && Number(localStorage.getItem("UserId")) != undefined && Number(localStorage.getItem("UserId")) != null) {

        for (let i = 0; i < this.agencySuppliers.length; i++) {
          for (let j = 0; j < this.agencySuppliers[i].supplierBoolean.length; j++) {
            if (this.agencySuppliers[i].supplierBoolean[j].supplierOficeId == null
              || this.agencySuppliers[i].supplierBoolean[j].supplierOficeId == undefined
              || this.agencySuppliers[i].supplierBoolean[j].supplierOficeId == "") {
              document.getElementById("supplierError").innerHTML = "**Please Select atleast One OfficeId!";
              document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "**Please Select atleast One OfficeId!"
              setTimeout(function () {

                document.getElementById("supplierError").innerHTML = "";
                document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "";
              }
                , 8000);
              return false;
              break;
            }
            for (let k = j + 1; k < this.agencySuppliers[i].supplierBoolean.length; k++) {

              if (this.agencySuppliers[i].supplierBoolean[j].supplierOficeId == this.agencySuppliers[i].supplierBoolean[k].supplierOficeId) {
                document.getElementById("supplierError").innerHTML = "**You Can't Select Same OfficeId in One Supplier";
                document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "**You Can't Select Same OfficeId in One Supplier";
                setTimeout(function () {

                  document.getElementById("supplierError").innerHTML = "";
                  document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "";
                }
                  , 8000);
                return false;
                break;
              }
            }
          }
          this.agencySuppliers[i].createUser = Number(localStorage.getItem("UserId"));
          this.agencySuppliers[i].agency_Branch = this.agencyObj.agencyId;
        }

        for (let i = 0; i < this.insuranceSuppliers.length; i++) {
          for (let j = 0; j < this.insuranceSuppliers[i].supplierBoolean.length; j++) {
            if (this.insuranceSuppliers[i].supplierBoolean[j].supplierOficeId == null
              || this.insuranceSuppliers[i].supplierBoolean[j].supplierOficeId == undefined
              || this.insuranceSuppliers[i].supplierBoolean[j].supplierOficeId == "") {
              document.getElementById("supplierError").innerHTML = "**Please Select atleast One OfficeId!";
              document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "**Please Select atleast One OfficeId!"
              setTimeout(function () {

                document.getElementById("supplierError").innerHTML = "";
                document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "";
              }
                , 8000);
              return false;
              break;
            }
            for (let k = j + 1; k < this.insuranceSuppliers[i].supplierBoolean.length; k++) {

              if (this.insuranceSuppliers[i].supplierBoolean[j].supplierOficeId == this.insuranceSuppliers[i].supplierBoolean[k].supplierOficeId) {
                document.getElementById("supplierError").innerHTML = "**You Can't Select Same OfficeId in One Supplier";
                document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "**You Can't Select Same OfficeId in One Supplier";
                setTimeout(function () {

                  document.getElementById("supplierError").innerHTML = "";
                  document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "";
                }
                  , 8000);
                return false;
                break;
              }
            }
          }
          this.insuranceSuppliers[i].createUser = Number(localStorage.getItem("UserId"));
          this.insuranceSuppliers[i].agency_Branch = this.agencyObj.agencyId;
        }
      } else {
        document.getElementById("supplierError").innerHTML = "**Something Went Wrong";
        setTimeout(function () {
          document.getElementById("supplierError").innerHTML = "";
        }
          , 8000);
        return false;

      }
      let supplierslist = JSON.parse(JSON.stringify(this.agencySuppliers)) as SupplierRightsForAgencyAndBranchProperties[];
      for (let k = 0; k < this.insuranceSuppliers.length; k++) {
        supplierslist.push(this.insuranceSuppliers[k]); 
      }
     
      this.agencyService.CreateAgencySupplierRights(supplierslist).subscribe((data) => {
        if (data != null && data != false) {
          if (this.agencyObj.isAlreadyActive == false) {
            this.agencyObj.isAlreadyActive = true;
            this.agencyObj.status = true;
          }
          if (req === 'save') {
            this.router.navigateByUrl("/flightSearch")
          } else {
            this.stepNine = true;
            localStorage.removeItem("isFromAgencyList");
            localStorage.setItem("isFromAgencyList", "True");
            this.supplierRightsComplete = false;
            this.revenueRightsComplete = true;
          }
          //this.router.navigateByUrl("/agencyList")    
        }
        else {
          document.getElementById("supplierError").innerHTML = "**Something Went Wrong";
          setTimeout(function () {
            document.getElementById("supplierError").innerHTML = "";
          }
            , 8000);
        }

      })
    }
    catch (e) { }
  }

  checkCreditRight(): boolean {
    let ans = false;
    this.agencyService.CheckCreditLimitRightAgaintAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {

      ans = data

    });
    return ans;
  }
  loginCheck: boolean;
  CheckLoginName() {
    if (this.agencyObj.userObj.loginName != "" && this.agencyObj.userObj.loginName != null && this.agencyObj.userObj.loginName != undefined) {
      this.agencyService.GetCheckLoginNameAvaliability(this.agencyObj.userObj.loginName).subscribe((data) => {
        if (data == false) {
          this.loginCheck = true;
        }
        else if (data == true) {
          document.getElementById("loginnamemessage").innerHTML = "Login Name already exsist choose another one";
          setTimeout(function () {
            document.getElementById("loginnamemessage").innerHTML = "";
          }
            , 6000);
          this.loginCheck = false;
        }

      });
    }
    return this.loginCheck;

  }
  colorarray = ['#0081AB', '#299617', '#C46210', '#2243B6', '#5DADEC', '#5946B2', '#A83731', '#9C51B6', '#AF6E4D', '#1B1B1B', '#FF5470', '#FF7A00', '#87FF2A', '#0048BA', '#9FE2BF', '#6495ED',
    '#FFAA1D', '#299617', '#FFF700', '#2243B6', '#5DADEC', '#5946B2', '#A83731', '#9C51B6', '#AF6E4D', '#1B1B1B', '#FF5470', '#FF7A00', '#87FF2A', '#0048BA', '#9FE2BF', '#6495ED'];
  showadminInfoPassowrd() {
    var x = document.getElementById("tbpassword") as HTMLInputElement;

    if (x.type === "password") {
      x.type = "text";
      document.getElementById("togglePassword").classList.toggle("fa-eye");
      document.getElementById("togglePassword").classList.remove("fa-eye-slash");
    } else {
      x.type = "password";
      document.getElementById("togglePassword").classList.add("fa-eye-slash");
      document.getElementById("togglePassword").classList.remove("fa-eye");
    }
  }


  CheckAdminValidations(): boolean {
    try {
      let isNewAdminUser = this.agencyObj.userObj.userId == 0 || this.agencyObj.userObj.userId == null || this.agencyObj.userObj.userId == undefined;
      if (this.agencyObj.userObj.backSystemCompanyId == 0 || this.agencyObj.userObj.backSystemCompanyId == null || this.agencyObj.userObj.backSystemCompanyId == undefined) {
        /*      box input id here*/
        document.getElementById("backSystemCompanyId").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelofCompanyinfo").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduserbackSystemCompanyId").innerHTML = "Required Company";
        setTimeout(function () {

          document.getElementById("backSystemCompanyId").classList.remove("newRequired-BoxColor");
          document.getElementById("labelofCompanyinfo").style.color = "";
          document.getElementById("requireduserbackSystemCompanyId").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.userObj.backSystemCompanyCustomer == "" || this.agencyObj.userObj.backSystemCompanyCustomer == null || this.agencyObj.userObj.backSystemCompanyCustomer == undefined) {
        /*      box input id here*/
        document.getElementById("backSystemCompanyCustomer").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelcustomercode").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduserbackSystemCompanyCustomer").innerHTML = "Required Customer";
        setTimeout(function () {

          document.getElementById("backSystemCompanyCustomer").classList.remove("newRequired-BoxColor");
          document.getElementById("labelcustomercode").style.color = "";
          document.getElementById("requireduserbackSystemCompanyCustomer").innerHTML = "";
        }
          , 8000);
      }

      if (this.agencyObj.userObj.title == "" || this.agencyObj.userObj.title == null || this.agencyObj.userObj.title == undefined) {
        /*      box input id here*/
        document.getElementById("tbtitle").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labeltitleuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredusertitle").innerHTML = "Required Title";
        setTimeout(function () {

          document.getElementById("tbtitle").classList.remove("newRequired-BoxColor");
          document.getElementById("labeltitleuser").style.color = "";
          document.getElementById("requiredusertitle").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.userObj.loginName == "" || this.agencyObj.userObj.loginName == null || this.agencyObj.userObj.loginName == undefined) {
        /*      box input id here*/
        document.getElementById("tbloginName").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelloginuser").style.color = "red";
        /*   message id here*/
        document.getElementById("loginnamemessage").innerHTML = "Required Login Name";
        setTimeout(function () {

          document.getElementById("tbloginName").classList.remove("newRequired-BoxColor");
          document.getElementById("labelloginuser").style.color = "";
          document.getElementById("loginnamemessage").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.userObj.firstName == "" || this.agencyObj.userObj.firstName == null || this.agencyObj.userObj.firstName == undefined) {
        /*      box input id here*/
        document.getElementById("tbfirstName").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelnamefuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduserfirst").innerHTML = "Required First Name";
        setTimeout(function () {

          document.getElementById("tbfirstName").classList.remove("newRequired-BoxColor");
          document.getElementById("labelnamefuser").style.color = "";
          document.getElementById("requireduserfirst").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.userObj.lastName == "" || this.agencyObj.userObj.lastName == null || this.agencyObj.userObj.lastName == undefined) {
        /*      box input id here*/
        document.getElementById("tblastName").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelnameluser").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduserlast").innerHTML = "Required Last Name";
        setTimeout(function () {

          document.getElementById("tblastName").classList.remove("newRequired-BoxColor");
          document.getElementById("labelnameluser").style.color = "";
          document.getElementById("requireduserlast").innerHTML = "";
        }
          , 8000);
      }
      if (isNewAdminUser && (this.agencyObj.userObj.password == "" || this.agencyObj.userObj.password == null || this.agencyObj.userObj.password == undefined)) {
        /*      box input id here*/
        document.getElementById("tbpassword").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelpswduser").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduserpswd").innerHTML = "Required Password";
        setTimeout(function () {

          document.getElementById("tbpassword").classList.remove("newRequired-BoxColor");
          document.getElementById("labelpswduser").style.color = "";
          document.getElementById("requireduserpswd").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.userObj.email == "" || this.agencyObj.userObj.email == null || this.agencyObj.userObj.email == undefined) {
        /*      box input id here*/
        document.getElementById("tbAdminemail").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelemailadres").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduseremail").innerHTML = "Required Email";
        setTimeout(function () {

          document.getElementById("tbAdminemail").classList.remove("newRequired-BoxColor");
          document.getElementById("labelemailadres").style.color = "";
          document.getElementById("requireduseremail").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.userObj.mobile == "" || this.agencyObj.userObj.mobile == null || this.agencyObj.userObj.mobile == undefined) {
        /*      box input id here*/
        document.getElementById("tbAdminmobile").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelmobileuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredusermobile").innerHTML = "Required Mobile";
        setTimeout(function () {

          document.getElementById("tbAdminmobile").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmobileuser").style.color = "";
          document.getElementById("requiredusermobile").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.userObj.telephone == "" || this.agencyObj.userObj.telephone == null || this.agencyObj.userObj.telephone == undefined) {
        /*      box input id here*/
        document.getElementById("tbAdmintelephone").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelteleuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredusertelephone").innerHTML = "Required Telephone";
        setTimeout(function () {

          document.getElementById("tbAdmintelephone").classList.remove("newRequired-BoxColor");
          document.getElementById("labelteleuser").style.color = "";
          document.getElementById("requiredusertelephone").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.userObj.designation == "" || this.agencyObj.userObj.designation == null || this.agencyObj.userObj.designation == undefined) {
        /*      box input id here*/
        document.getElementById("tbdesignation").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labeldesignuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduserdesignation").innerHTML = "Required Designation";
        setTimeout(function () {

          document.getElementById("tbdesignation").classList.remove("newRequired-BoxColor");
          document.getElementById("labeldesignuser").style.color = "";
          document.getElementById("requireduserdesignation").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.maximumUsers <= 0 || this.agencyObj.maximumUsers == null) {
        /*      box input id here*/
        document.getElementById("tbMaxUsers").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelmaxuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredusermax").innerHTML = "Required Users Limit";
        setTimeout(function () {

          document.getElementById("tbMaxUsers").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmaxuser").style.color = "";
          document.getElementById("requiredusermax").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.userObj.isAgencyAdmin == false) {

        document.getElementById("requireduseradministrator").innerHTML = "Required";
        setTimeout(function () {


          document.getElementById("requireduseradministrator").innerHTML = "";
        }
          , 8000);
      }

      if (this.agencyObj.userObj.title == "" || this.agencyObj.userObj.title == undefined || this.agencyObj.userObj.title == null ||
        this.agencyObj.userObj.firstName == "" || this.agencyObj.userObj.firstName == null || this.agencyObj.userObj.firstName == undefined
        || this.agencyObj.userObj.lastName == "" || this.agencyObj.userObj.lastName == null || this.agencyObj.userObj.lastName == undefined
        || this.agencyObj.userObj.loginName == "" || this.agencyObj.userObj.loginName == null || this.agencyObj.userObj.loginName == undefined
        || (isNewAdminUser && (this.agencyObj.userObj.password == "" || this.agencyObj.userObj.password == null || this.agencyObj.userObj.password == undefined))
        || this.agencyObj.userObj.email == "" || this.agencyObj.userObj.email == null || this.agencyObj.userObj.email == undefined
        || this.agencyObj.userObj.mobile == "" || this.agencyObj.userObj.mobile == null || this.agencyObj.userObj.mobile == undefined
        || this.agencyObj.userObj.telephone == "" || this.agencyObj.userObj.telephone == null || this.agencyObj.userObj.telephone == undefined
        || this.agencyObj.userObj.designation == "" || this.agencyObj.userObj.designation == null || this.agencyObj.userObj.designation == undefined
        || this.agencyObj.maximumUsers == 0 || this.agencyObj.maximumUsers == null
        || this.agencyObj.userObj.isAgencyAdmin == false
        || this.agencyObj.userObj.backSystemCompanyId == 0 || this.agencyObj.userObj.backSystemCompanyId == null || this.agencyObj.userObj.backSystemCompanyId == undefined
        || this.agencyObj.userObj.backSystemCompanyCustomer == "" || this.agencyObj.userObj.backSystemCompanyCustomer == null || this.agencyObj.userObj.backSystemCompanyCustomer == undefined) {
        return false;
      }
      if (!this.validateEmail(this.agencyObj.userObj.email)) {
        /*      box input id here*/
        document.getElementById("tbAdminemail").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelemailadres").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduseremail").innerHTML = "Email Pattern Must be Followed";
        setTimeout(function () {

          document.getElementById("tbAdminemail").classList.remove("newRequired-BoxColor");
          document.getElementById("labelemailadres").style.color = "";
          document.getElementById("requireduseremail").innerHTML = "";
        }
          , 8000);
        return false;
      }
      if (!this.validateMobileNumber(this.agencyObj.userObj.mobile)) {
        /*      box input id here*/
        document.getElementById("tbAdminmobile").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelmobileuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredusermobile").innerHTML = "Mobile Start with + Sign";
        setTimeout(function () {

          document.getElementById("tbAdminmobile").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmobileuser").style.color = "";
          document.getElementById("requiredusermobile").innerHTML = "";
        }
          , 8000);
        return false;
      }
      if (!this.validateNumber(this.agencyObj.userObj.telephone)) {
        /*      box input id here*/
        document.getElementById("tbAdmintelephone").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelteleuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredusertelephone").innerHTML = "Telephone Start with + Sign";
        setTimeout(function () {

          document.getElementById("tbAdmintelephone").classList.remove("newRequired-BoxColor");
          document.getElementById("labelteleuser").style.color = "";
          document.getElementById("requiredusertelephone").innerHTML = "";
        }
          , 8000);
        return false;
      }
      else {
        // this.stepFour = true;
        return true;
      }
    }

    catch (e) {
      console.log(e);
    }
  }

  /*----------------------------Validation of agency info page Required----------------------------*/
  ValidationOfAgencyInfoPage() {
    try {

      if (this.agencyObj.backCompanyId <= 0 || this.agencyObj.backCompanyId == undefined || this.agencyObj.backCompanyId == null) {
        /*      box input id here*/
        document.getElementById("backCompanyListInput").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelBackCompany").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredBackCompany").innerHTML = "Please Select Company";
        setTimeout(function () {

          document.getElementById("backCompanyListInput").classList.remove("newRequired-BoxColor");
          document.getElementById("labelBackCompany").style.color = "";
          document.getElementById("requiredBackCompany").innerHTML = "";
        }
          , 7000);
        return false;
      }

      if (this.agencyObj.agencyId != "AG01") {
        if (this.agencyObj.parentAgency == "" || this.agencyObj.parentAgency == undefined || this.agencyObj.parentAgency == null) {
          /*      box input id here*/
          document.getElementById("agencyListInput").classList.add("newRequired-BoxColor");
          /*   label id here*/
          document.getElementById("labelparentagency").style.color = "red";
          /*   message id here*/
          document.getElementById("requiredparentagency").innerHTML = "Required Parent Agency";
          setTimeout(function () {

            document.getElementById("agencyListInput").classList.remove("newRequired-BoxColor");
            document.getElementById("labelparentagency").style.color = "";
            document.getElementById("requiredparentagency").innerHTML = "";
          }
            , 8000);
          return;
        }

      }
      if (this.pendingCreditDecreased == true) {

        /*      box input id here*/
        document.getElementById("tbCredit").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelcredit").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredcreditlimit").innerHTML = "You cannot decrease Credit Limit";
        setTimeout(function () {

          document.getElementById("tbCredit").classList.remove("newRequired-BoxColor");
          document.getElementById("labelcredit").style.color = "";
          document.getElementById("requiredcreditlimit").innerHTML = "";
        }
          , 8000);
        return false;
      }

      if (this.agencyObj.agencyName == "" || this.agencyObj.agencyName == undefined || this.agencyObj.agencyName == null) {
        /*      box input id here*/
        document.getElementById("tbname").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelagencyname").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredagencyname").innerHTML = "Required Agency Name";
        setTimeout(function () {

          document.getElementById("tbname").classList.remove("newRequired-BoxColor");
          document.getElementById("labelagencyname").style.color = "";
          document.getElementById("requiredagencyname").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.notificationEmail == "" || this.agencyObj.notificationEmail == undefined || this.agencyObj.notificationEmail == null) {
        /*      box input id here*/
        document.getElementById("notifyemail").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelnotifyemail").style.color = "red";
        /*   message id here*/
        document.getElementById("requirednotifyemail").innerHTML = "Required Notify Email";
        setTimeout(function () {

          document.getElementById("notifyemail").classList.remove("newRequired-BoxColor");
          document.getElementById("labelnotifyemail").style.color = "";
          document.getElementById("requirednotifyemail").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.emailAddress == "" || this.agencyObj.emailAddress == undefined || this.agencyObj.emailAddress == null) {
        /*      box input id here*/
        document.getElementById("tbAgencyemail").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelemail").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredemail").innerHTML = "Required Email";
        setTimeout(function () {

          document.getElementById("tbAgencyemail").classList.remove("newRequired-BoxColor");
          document.getElementById("labelemail").style.color = "";
          document.getElementById("requiredemail").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.address1 == "" || this.agencyObj.address1 == undefined || this.agencyObj.address1 == null) {
        /*      box input id here*/
        document.getElementById("tbAddress1").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labeladdress1").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredaddres1").innerHTML = "Required Address";
        setTimeout(function () {

          document.getElementById("tbAddress1").classList.remove("newRequired-BoxColor");
          document.getElementById("labeladdress1").style.color = "";
          document.getElementById("requiredaddres1").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.address2 == "" || this.agencyObj.address2 == undefined || this.agencyObj.address2 == null) {
        /*      box input id here*/
        document.getElementById("tbAddress2").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labeladdress2").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredaddress2").innerHTML = "Required Address";
        setTimeout(function () {

          document.getElementById("tbAddress2").classList.remove("newRequired-BoxColor");
          document.getElementById("labeladdress2").style.color = "";
          document.getElementById("requiredaddress2").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.country == "" || this.agencyObj.country == undefined || this.agencyObj.country == null) {
        /*      box input id here*/
        document.getElementById("tbCountry").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelcountry").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredcountry").innerHTML = "Required Country";
        setTimeout(function () {

          document.getElementById("tbCountry").classList.remove("newRequired-BoxColor");
          document.getElementById("labelcountry").style.color = "";
          document.getElementById("requiredcountry").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.city == "" || this.agencyObj.city == undefined || this.agencyObj.city == null) {
        /*      box input id here*/
        document.getElementById("tbCity").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelcity").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredcity").innerHTML = "Required City";
        setTimeout(function () {

          document.getElementById("tbCity").classList.remove("newRequired-BoxColor");
          document.getElementById("labelcity").style.color = "";
          document.getElementById("requiredcity").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.zip == "" || this.agencyObj.zip == undefined || this.agencyObj.zip == null) {
        /*      box input id here*/
        document.getElementById("tbZip").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelzip").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredzip").innerHTML = "Required Zip";
        setTimeout(function () {

          document.getElementById("tbZip").classList.remove("newRequired-BoxColor");
          document.getElementById("labelzip").style.color = "";
          document.getElementById("requiredzip").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.currency == 0 || this.agencyObj.currency == undefined || this.agencyObj.currency == null) {
        /*      box input id here*/
        document.getElementById("inputcurrency").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelcurrency").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredcurrency").innerHTML = "Required Currency";
        setTimeout(function () {

          document.getElementById("inputcurrency").classList.remove("newRequired-BoxColor");
          document.getElementById("labelcurrency").style.color = "";
          document.getElementById("requiredcurrency").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.language == 0 || this.agencyObj.language == undefined || this.agencyObj.language == null) {
        /*      box input id here*/
        document.getElementById("inputlanguage").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labellanguage").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredlanguage").innerHTML = "Required Language";
        setTimeout(function () {

          document.getElementById("inputlanguage").classList.remove("newRequired-BoxColor");
          document.getElementById("labellanguage").style.color = "";
          document.getElementById("requiredlanguage").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.mobileContact == "" || this.agencyObj.mobileContact == undefined || this.agencyObj.mobileContact == null) {
        /*      box input id here*/
        document.getElementById("tbmobileNo").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelmobile").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredmobile").innerHTML = "Required Mobile";
        setTimeout(function () {

          document.getElementById("tbmobileNo").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmobile").style.color = "";
          document.getElementById("requiredmobile").innerHTML = "";
        }
          , 8000);
      }
      if (this.agencyObj.telephoneNumber == "" || this.agencyObj.telephoneNumber == undefined || this.agencyObj.telephoneNumber == null) {
        /*      box input id here*/
        document.getElementById("tbTelephoneNo").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labetelephone").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredtelephone").innerHTML = "Required Telephone";
        setTimeout(function () {

          document.getElementById("tbTelephoneNo").classList.remove("newRequired-BoxColor");
          document.getElementById("labetelephone").style.color = "";
          document.getElementById("requiredtelephone").innerHTML = "";
        }
          , 8000);
      }
      //if (this.agencyObj.creditLimit == 0 || this.agencyObj.creditLimit == undefined || this.agencyObj.creditLimit == null) {
      //  /*      box input id here*/
      //  document.getElementById("tbCredit").classList.add("newRequired-BoxColor");
      //  /*   label id here*/
      //  document.getElementById("labelcredit").style.color = "red";
      //  /*   message id here*/
      //  document.getElementById("requiredcreditlimit").innerHTML = "Required Credits";
      //  setTimeout(function () {

      //    document.getElementById("tbCredit").classList.remove("newRequired-BoxColor");
      //    document.getElementById("labelcredit").style.color = "";
      //    document.getElementById("requiredcreditlimit").innerHTML = "";
      //  }
      //    , 8000);
      //}
      if (this.agencyObj.settlementMode == 2) {
        if (this.agencyObj.creditLimit == 0 || this.agencyObj.creditLimit == undefined || this.agencyObj.creditLimit == null) {
          /*      box input id here*/
          document.getElementById("tbCredit").classList.add("newRequired-BoxColor");
          /*   label id here*/
          document.getElementById("labelcredit").style.color = "red";
          /*   message id here*/
          document.getElementById("requiredcreditlimit").innerHTML = "Required Credits";
          setTimeout(function () {

            document.getElementById("tbCredit").classList.remove("newRequired-BoxColor");
            document.getElementById("labelcredit").style.color = "";
            document.getElementById("requiredcreditlimit").innerHTML = "";
          }
            , 8000);
          return false;
        }
      }
      if (this.checkImgUpload == false) {

        document.getElementById("requiredlogo").innerHTML = "Required Logo";
        setTimeout(function () {

          document.getElementById("requiredlogo").innerHTML = "";
        }
          , 8000);
      }
      if (
        this.agencyObj.agencyName == "" || this.agencyObj.agencyName == undefined || this.agencyObj.agencyName == null ||
        this.agencyObj.notificationEmail == "" || this.agencyObj.notificationEmail == undefined || this.agencyObj.notificationEmail == null ||
        this.agencyObj.emailAddress == "" || this.agencyObj.emailAddress == undefined || this.agencyObj.emailAddress == null ||
        this.agencyObj.address1 == "" || this.agencyObj.address1 == undefined || this.agencyObj.address1 == null ||
        this.agencyObj.address2 == "" || this.agencyObj.address2 == undefined || this.agencyObj.address2 == null ||
        this.agencyObj.country == "" || this.agencyObj.country == undefined || this.agencyObj.country == null ||
        this.agencyObj.city == "" || this.agencyObj.city == undefined || this.agencyObj.city == null ||
        this.agencyObj.zip == "" || this.agencyObj.zip == undefined || this.agencyObj.zip == null ||
        this.agencyObj.currency == 0 || this.agencyObj.currency == undefined || this.agencyObj.currency == null ||
        this.agencyObj.language == 0 || this.agencyObj.language == undefined || this.agencyObj.language == null ||
        this.agencyObj.mobileContact == "" || this.agencyObj.mobileContact == undefined || this.agencyObj.mobileContact == null ||
        this.agencyObj.telephoneNumber == "" || this.agencyObj.telephoneNumber == undefined || this.agencyObj.telephoneNumber == null
        ||
        this.checkImgUpload == false) {
        return false;
      }
      if (!this.validateMobileNumber(this.agencyObj.mobileContact)) {
        document.getElementById("tbmobileNo").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelmobile").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredmobile").innerHTML = "Must Start with + sign";
        setTimeout(function () {

          document.getElementById("tbmobileNo").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmobile").style.color = "";
          document.getElementById("requiredmobile").innerHTML = "";
        }
          , 8000);
        return false;
      }
      if (this.agencyObj.fax != "") {
        if (!this.validateNumber(this.agencyObj.fax)) {
          document.getElementById("tbFax").classList.add("newRequired-BoxColor");
          /*   label id here*/
          document.getElementById("labelfax").style.color = "red";
          /*   message id here*/
          document.getElementById("requiredfax").innerHTML = "Fax Field Must Be a Number";
          setTimeout(function () {

            document.getElementById("tbFax").classList.remove("newRequired-BoxColor");
            document.getElementById("labelfax").style.color = "";
            document.getElementById("requiredfax").innerHTML = "";
          }
            , 8000);
          return false;
        }
      }
      if (this.creditCheck == true) {

        /*      box input id here*/
        document.getElementById("tbCredit").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelcredit").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredcreditlimit").innerHTML = "Credit Should less from Parent";
        setTimeout(function () {

          document.getElementById("tbCredit").classList.remove("newRequired-BoxColor");
          document.getElementById("labelcredit").style.color = "";
          document.getElementById("requiredcreditlimit").innerHTML = "";
        }
          , 8000);
        return false;
      }
      if (!this.validateEmail(this.agencyObj.emailAddress)) {
        // this.emailValid.focus();
        /*      box input id here*/
        document.getElementById("tbAgencyemail").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelemail").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredemail").innerHTML = "Email Pattern Must Be True";
        setTimeout(function () {

          document.getElementById("tbAgencyemail").classList.remove("newRequired-BoxColor");
          document.getElementById("labelemail").style.color = "";
          document.getElementById("requiredemail").innerHTML = "";
        }
          , 8000);

        return false;
      }

      if (this.agencyObj.maximumUsers < 0 || this.agencyObj.maximumUsers == undefined || this.agencyObj.maximumUsers == null) {
        /*      box input id here*/
        document.getElementById("tbMaxUsers").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelmaxuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredusermax").innerHTML = "Required MaxUsers";
        setTimeout(function () {

          document.getElementById("tbMaxUsers").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmaxuser").style.color = "";
          document.getElementById("requiredusermax").innerHTML = "";
        }
          , 8000);
      }

      //14-june-23
      if (this.agencyObj.maximumChildAgencies < 0 || this.agencyObj.maximumChildAgencies == undefined || this.agencyObj.maximumChildAgencies == null) {
        /*      box input id here*/
        document.getElementById("tbMaxChildAgency").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelmaxAgency").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredAgencymax").innerHTML = "Should not be Empty or greater Than Equal 0";
        setTimeout(function () {

          document.getElementById("tbMaxChildAgency").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmaxAgency").style.color = "";
          document.getElementById("requiredAgencymax").innerHTML = "";
        }
          , 8000);
        return false;
      }
      if (this.agencyObj.maximumChildBranches < 0 || this.agencyObj.maximumChildBranches == undefined || this.agencyObj.maximumChildBranches == null) {
        /*      box input id here*/
        document.getElementById("tbMaxChildBranch").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelmaxbranch").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredbranchmax").innerHTML = "Should not be Empty or greater Than Equal 0";
        setTimeout(function () {

          document.getElementById("tbMaxChildbranch").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmaxbranch").style.color = "";
          document.getElementById("requiredbranchmax").innerHTML = "";
        }
          , 8000);
        return false;
      }

      else {
        return true;
      }

    }
    catch (e) {
    }
  }
  /*---------------------------agency branch save here this two function--------------------------*/
  agencyInfoClick = (req: string): boolean => {
    try {
      if (!this.ValidationOfAgencyInfoPage()) {
        return;
      }
      if (this.userlimitreached == true) {
        return;
      }
      if (this.agencyObj.isAlreadyActive == false) {
        this.agencyObj.pendingcreditLimit = this.agencyObj.creditLimit;
      }

      this.agencyObj.agencyColourCode = this.agencyColor;
      if (this.checkImgUpload == true) {

        if (this.AgencyInfoValidations()) {
          try {
            if (this.agencyObj.immediateParent == null || this.agencyObj.immediateParent == "") {
              if (this.agencyObj.agencyId == 'AG01')
                this.agencyObj.immediateParent = "";
              else
                this.agencyObj.immediateParent = this.agencyObj.parentAgency;
            }
            let flag = false;
            let userId = 0;
            if (localStorage.getItem("UserId") != undefined && localStorage.getItem("UserId") != null) {
              userId = Number(localStorage.getItem("UserId"))
              if (userId != 0) {
                /*--------------------------create call of new agency--------------------*/
                if (this.agencyObj.agencyId == "" || this.agencyObj.agencyId == undefined) {
                  this.CheckChildAgenciesLimit().subscribe((r) => {
                    if (r == true) {
                      this.agencyObj.creationUser = userId;
                      this.agencyService.CreateAgency(this.agencyObj).subscribe((data) => {
                        if (data.isSave == true) {
                          this.agencyObj.agencyId = data.agencyId;
                          this.creationAgency = this.agencyObj.agencyId;
                          flag = true;
                          if (this.agencyAG01 == "AG01") {
                            this.agencyInfoComplete = false;
                            this.BackOfficeInfoComplete = true;
                            this.stepTwo = true;
                          }
                          else {

                            this.agencyInfoComplete = false;
                            this.BackOfficeInfoComplete = false;
                            this.stepTwo = false;
                            this.agencyRightsComplete = true;
                            this.stepThree = true;
                          }

                          if (this.agencyObj.agencyId == "AG01") {
                            this.selectMultipleBackSystemCustomer = true;
                          }
                          else {
                            this.selectMultipleBackSystemCustomer = false;
                          }

                          if (this.agencyObj.immediateParent != "AG01") {
                            this.backsystemgetinfo(this.agencyObj.immediateParent);
                          }
                          this.currencyCodeList$.subscribe(data => {
                            const currencyList = data.find(id => id.currencyId === this.agencyObj.currency);
                            const comapnyList = this.backSystemCompanies.filter(company =>
                              currencyList.currencyName.includes(company.companyCurrency));
                            this.backSystemCompanies = comapnyList;

                          });

                        }
                        else {
                          flag = false;
                          $("#lblerrormsg").show();
                          document.getElementById("lblerrormsg").innerHTML = "Something went wrong on Creating Agency."
                          $("#lblerrormsg").delay(5000).hide(10);
                        }
                      });
                      return flag;
                    }
                  })
                }
                /*------------------------------------ update call of agency-----------------------------*/
                else {
                  this.agencyObj.modifyUser = userId;
                  this.agencyService.UpdateAgency(this.agencyObj).subscribe((data) => {
                    if (data == true) {
                      this.backsystemgetinfo(this.agencyObj.agencyId);
                      if (this.agencyAG01 == "AG01") {
                        this.agencyInfoComplete = false;
                        this.BackOfficeInfoComplete = true;
                        this.stepTwo = true;
                      }
                      else {
                        this.agencyInfoComplete = false;
                        this.BackOfficeInfoComplete = false;
                        this.stepTwo = false;
                        this.agencyRightsComplete = true;
                        this.stepThree = true;
                      }
                      if (this.agencyObj.agencyId == "AG01") {
                        this.selectMultipleBackSystemCustomer = true;
                      }
                      else {
                        this.selectMultipleBackSystemCustomer = false;
                      }
                      if (this.agencyObj.immediateParent != "AG01") {
                        this.backsystemgetinfo(this.agencyObj.immediateParent);
                      }
                      this.currencyCodeList$.subscribe(data => {
                        const currencyList = data.find(id => id.currencyId === this.agencyObj.currency);
                        const comapnyList = this.backSystemCompanies.filter(company =>
                          currencyList.currencyName.includes(company.companyCurrency));
                        this.backSystemCompanies = comapnyList;

                      });

                    }
                    else {
                      $("#lblerrormsg").show();
                      document.getElementById("lblerrormsg").innerHTML = "Something went wrong on Updating Agency."
                      $("#lblerrormsg").delay(5000).hide(10);
                    }
                  });
                }
              }
            }
          } catch (e) {
            console.log(e);
          }
        }
        if (req === 'save') {
          this.router.navigateByUrl("/flightSearch")
        }
      }
    }
    catch (e) { console.log(e) }
  }
  /*----------------------Back system office procedure start here------------------------------*/
  GetParentBackSystemCompanies = (parentId: string): void => {
    this.agencyService.GetParentBackSystemCompanies(parentId).subscribe(data => {
      this.backsystemParentCompanies = data;
      const backCompanies = this.backSystemCompanies.filter(company => company.companyId === this.backsystemParentCompanies.backSystemCompanyId);
      this.backSystemCompanies = backCompanies;
      //console.log(this.backSystemCompanies)
      for (let i = 0; i < this.backsystemOfficeProperties.length; i++) {
        // console.log(this.backsystemOfficeProperties[i].customerCodesList)
        const backCustomer = this.backsystemOfficeProperties[i].customerCodesList.filter(customer =>
          customer.customerCode === this.backsystemParentCompanies.backSystemCustomerCode);
        this.backsystemOfficeProperties[i].customerCodesList = backCustomer
        // console.log(backCustomer);
      };
      //console.log(this.backsystemOfficeProperties[0].customerCodesList)
    })

  }
  backsystemgetinfo = (agency: string): void => {
    this.agencyService.GetBackSystemByid(agency).subscribe((data) => {
      if (data.length > 0) {
        this.backSystemAllList = [];
        this.backSystemCompanyIds = []
        this.backSystemAllList = data;
        this.backSystemAllList.forEach((item, index: number) => {
          let back = new BackSystemOfficeProperties()
          back.backSystemCompanyId = item.backSystemCompanyId;
          back.agecnyBranchID = item.agecnyBranchID;
          if (item.backSystemCompanyId != 0 && item.backSystemCompanyId != null && item.backSystemCompanyId != undefined) {
            let companyURL = "";
            for (let i = 0; i < this.backSystemCompanies.length; i++) {
              if (item.backSystemCompanyId == this.backSystemCompanies[i].companyId) {
                companyURL = this.backSystemCompanies[i].companyURL;
                this.loaderVar = true;
                break;
              }

            }
            var req = new UrlRequest();
            req.request = companyURL;
            this.agencyService.GetCustomerCodeByID(req).subscribe((data) => {
              this.backsystemOfficeProperties[index].customerCodesList = data

              this.loaderVar = false;
            });
          }

          item.backSystemAll.forEach((c) => {
            back.backSystemCompanyCustomer.push(c.backSystemCompanyCustomer);
          });
          this.backsystemOfficeProperties.push(back);
          let companyName = new BackSystemCompanyId();
          companyName.backSystemCompanyId = item.backSystemCompanyId;
          this.backSystemCompanyIds.push(companyName);
        });


        if (this.agencyObj.agencyId != "AG01") {
          for (let index = 0; index < this.backsystemOfficeProperties.length; index++) {
            this.backsystemOfficeProperties[index].selectSingleBackSystemCustomer = this.backsystemOfficeProperties[index].backSystemCompanyCustomer[0];
          }
        }
        if (this.agencyObj.immediateParent != "AG01") {
          setTimeout(() => {
            this.GetParentBackSystemCompanies(this.agencyObj.immediateParent);
          }, 500)
        }
        this.backSystemCompaniesForAdminInfo = [];
        for (let i = 0; i < this.backSystemCompanyIds.length; i++) {
          for (let j = 0; j < this.backSystemCompanies.length; j++) {
            if (this.backSystemCompanies[j].companyId == this.backSystemCompanyIds[i].backSystemCompanyId) {
              let backSystem = new CompanyMasterProperties();
              backSystem.companyId = this.backSystemCompanies[j].companyId;
              backSystem.companyName = this.backSystemCompanies[j].companyName;
              this.backSystemCompaniesForAdminInfo.push(backSystem);
              break;
            }
          }
        }
        for (let j = 0; j < this.backSystemCompaniesForAdminInfo.length; j++) {
          if (this.backSystemCompaniesForAdminInfo[j].companyId == this.agencyObj.userObj.backSystemCompanyId) {
            this.GetSelectedBackSystemCustomers(this.agencyObj.userObj.backSystemCompanyId);
            break;
          }
        }

      }
    });
  }
  BackOfficeInfobackClick() {
    this.BackOfficeInfoComplete = false;
    this.agencyInfoComplete = true;
    this.stepTwo = false;
    this.backsystemOfficeProperties = []
  }
  OnCustomerCodeChange = (customerCode: string, index: number): void => {
    this.backsystemOfficeProperties[index].backSystemCompanyCustomer = [];
    this.backsystemOfficeProperties[index].backSystemCompanyCustomer.push(customerCode);

  }
  backSystemInfoSave = (req: string): boolean => {

    let agencyId = this.agencyObj.agencyId;
    if (this.backsystemOfficeProperties.length > 0) {
      for (let i = 0; i < this.backsystemOfficeProperties.length; i++) {

        if (this.backsystemOfficeProperties[i].backSystemCompanyId == null || this.backsystemOfficeProperties[i].backSystemCompanyId == 0 || this.backsystemOfficeProperties[i].backSystemCompanyId == undefined) {
          /*      box input id here*/
          document.getElementById("Back_System_Companies" + i).classList.add("newRequired-BoxColor");
          /*   label id here*/
          document.getElementById("Back_System_CompaniesLabel" + i).style.color = "red";
          /*   message id here*/
          document.getElementById("Back_System_CompaniesError" + i).innerHTML = "Please Select Back System Company";
          setTimeout(function () {

            document.getElementById("Back_System_Companies" + i).classList.remove("newRequired-BoxColor");
            document.getElementById("Back_System_CompaniesLabel" + i).style.color = "";
            document.getElementById("Back_System_CompaniesError" + i).innerHTML = "";
          }
            , 8000);
          return false;
        }
        if (this.backsystemOfficeProperties[i].backSystemCompanyCustomer == null || this.backsystemOfficeProperties[i].backSystemCompanyCustomer.length == 0) {
          /*      box input id here*/
          document.getElementById("Customer_Code" + i).classList.add("newRequired-BoxColor");
          /*   label id here*/
          document.getElementById("Customer_CodeLabel" + i).style.color = "red";
          /*   message id here*/
          document.getElementById("Customer_CodeError" + i).innerHTML = "Please Select Customer Code";
          setTimeout(function () {

            document.getElementById("Customer_Code" + i).classList.remove("newRequired-BoxColor");
            document.getElementById("Customer_CodeLabel" + i).style.color = "";
            document.getElementById("Customer_CodeError" + i).innerHTML = "";
          }
            , 8000);
          return false;
        }

        if (agencyId != undefined) {
          this.backsystemOfficeProperties[i].agecnyBranchID = agencyId;
        }

      }
      for (let j = 0; j < this.backsystemOfficeProperties.length; j++) {
        for (let k = j + 1; k < this.backsystemOfficeProperties.length; k++) {
          if (this.backsystemOfficeProperties[j].backSystemCompanyId == this.backsystemOfficeProperties[k].backSystemCompanyId) {
            document.getElementById("backSystemInfoError").innerHTML = "**You Can't Select One Company Twice or More";
            setTimeout(function () {

              document.getElementById("backSystemInfoError").innerHTML = "";
            }
              , 8000);
            return false;
          }

        }
        for (let l = 0; l < this.backsystemOfficeProperties[j].backSystemCompanyCustomer.length; l++) {
          if (this.backsystemOfficeProperties[j].backSystemCompanyCustomer[l] == null) {
            document.getElementById("Customer_Code" + l).classList.add("newRequired-BoxColor");
            /*   label id here*/
            document.getElementById("Customer_CodeLabel" + l).style.color = "red";
            /*   message id here*/
            document.getElementById("Customer_CodeError" + l).innerHTML = "Please Select Customer Code";
            setTimeout(function () {

              document.getElementById("Customer_Code" + l).classList.remove("newRequired-BoxColor");
              document.getElementById("Customer_CodeLabel" + l).style.color = "";
              document.getElementById("Customer_CodeError" + l).innerHTML = "";
            }
              , 8000);
            return false;
          }
        }
      }
      this.backsystemOfficeProperties = this.backsystemOfficeProperties.map(data => {
        return { ...data, agecnyBranchIDParent: this.agencyObj.immediateParent }
      });

      this.agencyService.CreateBackSystemInfo(this.backsystemOfficeProperties).subscribe((data) => {
        if (data.isSave != false) {
          if (this.agencyObj.agencyId != "AG01") {
            // this.agencyObj.userObj.backSystemCompanyCustomer=this.backsystemOfficeProperties[0].selectSingleBackSystemCustomer
            // this.agencyObj.userObj.backSystemCompanyId=this.backsystemOfficeProperties[0].backSystemCompanyId;
          }
          this.BackOfficeInfoComplete = false;
          this.agencyRightsComplete = true;
          this.stepThree = true;

        }
        else {
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
          $("#lblerrormsg").delay(5000).hide(10);
        }
      });
    }
    else {
      $("#lblerrormsg").show();
      document.getElementById("lblerrormsg").innerHTML = "Please Select Atleast One company! ";
      $("#lblerrormsg").delay(5000).hide(10);
      // this.BackOfficeInfoComplete = false;
      // this.agencyRightsComplete = true;
      // this.stepThree = true;
    }
    if (req === 'save') {
      this.router.navigateByUrl("/flightSearch")
    }
    else {
      this.agencyService.AgencyBranchLimitationRights(this.agencyObj.agencyId).subscribe((data) => {
        this.AgencyBranchLimitationRights = data;
      });
    }

  }
  addBackOffice = (): void => {
    try {
      if (this.selectMultipleBackSystemCustomer == true) {
        let obj = new BackSystemOfficeProperties();
        this.backsystemOfficeProperties.push(obj);
      }
      else {
        if (this.backsystemOfficeProperties.length == 0) {
          let obj = new BackSystemOfficeProperties();
          this.backsystemOfficeProperties.push(obj);
        }
        else {
          document.getElementById("backSystemInfoError").innerHTML = "**You Can Only Add One Company";
          setTimeout(function () {

            document.getElementById("backSystemInfoError").innerHTML = "";
          }
            , 8000);
        }
      }

    } catch (e) {
      console.log(e);
    }
  }
  removeBackOffice(i) {
    try {
      this.backsystemOfficeProperties.splice(i, 1);
    } catch (e) {
      console.log(e);
    }
  }

  GetBackSystemCustomers = (companyId: number, index): void => {

    if (companyId != 0 && companyId != null && companyId != undefined) {
      let companyURL = "";
      for (let i = 0; i < this.backSystemCompanies.length; i++) {
        if (companyId == this.backSystemCompanies[i].companyId) {
          companyURL = this.backSystemCompanies[i].companyURL;
          this.loaderVar = true;
          break;
        }

      }
      var req = new UrlRequest();
      req.request = companyURL;
      this.agencyService.GetCustomerCodeByID(req).subscribe((data) => {

        this.backsystemOfficeProperties[index].customerCodesList = data
        this.loaderVar = false;
        if (this.agencyObj.immediateParent != "AG01") {
          const backCustomer = this.backsystemOfficeProperties[index].customerCodesList.filter(customer =>
            customer.customerCode === this.backsystemParentCompanies.backSystemCustomerCode);
          this.backsystemOfficeProperties[index].customerCodesList = backCustomer;
        }
      });

    }


  }


  /*--------------------------- managers save update rights assign here this three function--------------------------*/
  managerInfoClick = (req: string): boolean => {
    //console.log(localStorage.getItem("AgencyId"));
    //console.log(localStorage.getItem("ParentAgency"));
    try {
      this.CheckManagerValiations();
      if (this.ManagersValidation == true) {
        //adeel add this and message service in constructor
        this.messageservice.add({ severity: 'error', summary: 'Fail', detail: 'Already Selected! Please Select Other One' });
        return false;
      }
      else {
        this.messageservice.add({ severity: 'success', summary: 'Successfully', detail: 'Saved Successfuly' });
      }

      for (let i = 0; i < this.managerList.length; i++) {
        if (this.managerList[i].userId <= 0 || this.managerList[i].userId == undefined || this.managerList[i].userId == null
          || this.managerList[i].managerEmailAddress == null || this.managerList[i].managerEmailAddress == undefined || this.managerList[i].managerEmailAddress == ""
          || this.managerList[i].managerPhone == undefined || this.managerList[i].managerPhone == "" || this.managerList[i].managerPhone == null) {
          return;
        }

        if (!this.validateEmail(this.managerList[i].managerEmailAddress)) {
          document.getElementById(`tbmanagerEmail${i}`).classList.add("newRequired-BoxColor");
          /*   label id here*/
          document.getElementById(`labelmanagerEmail${i}`).style.color = "red";
          /*   message id here*/
          document.getElementById(`requiredmanagerEmail${i}`).innerHTML = "Email Pattern Must be Followed";
          setTimeout(function () {

            document.getElementById(`tbmanagerEmail${i}`).classList.remove("newRequired-BoxColor");
            document.getElementById(`labelmanagerEmail${i}`).style.color = "";
            document.getElementById(`requiredmanagerEmail${i}`).innerHTML = "";
          }
            , 8000);
          return;
        }
        if (!this.validateMobileNumber(this.managerList[i].managerPhone)) {
          document.getElementById(`tbManagerPhone${i}`).classList.add("newRequired-BoxColor");
          /*   label id here*/
          document.getElementById(`labelManagerPhone${i}`).style.color = "red";
          /*   message id here*/
          document.getElementById(`requiredManagerPhone${i}`).innerHTML = "Must Start with + sign";
          setTimeout(function () {

            document.getElementById(`tbManagerPhone${i}`).classList.remove("newRequired-BoxColor");
            document.getElementById(`labelManagerPhone${i}`).style.color = "";
            document.getElementById(`requiredManagerPhone${i}`).innerHTML = "";
          }
            , 8000);
          return;
        }
      }
      this.agencyObj.managers = [];
      for (let k = 0; k < this.managerList.length; k++) {
        let list = this.managerList[k] as ManagerProperties;
        if (list.userId != 0 && list.managerName != "") {
          this.agencyObj.managers.push(list);
        }
      }
      if (this.ParentManagerValidation() == false) {
        document.getElementById("managerInfoError").innerHTML = "**Please Select atleast One Parent Agency Managers";
        setTimeout(() => {
          document.getElementById("managerInfoError").innerHTML = "";
        }, 5000);
        return;
      }
      this.agencyService.CreateUpdateManagers(this.agencyObj).subscribe((data) => {
        if (data.isSave == true) {
          this.agencyObj.managers = data.managers;
          this.GetparentAgencyRights();
          this.managerInfoComplete = false;
          this.supplierRightsComplete = true;
          this.stepSix = true;
          this.revenueRightsComplete = false;
          this.stepNine = false;
          this.GetSuppliersByParent();

        }
        else {
          //console.log(data.message);
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = data.message;
          $("#lblerrormsg").delay(5000).hide(10);
        }
      });
      this.agencyService.checkCurrencyRightAgainstAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {
        if (data)
          this.currencyRight = true;


      });
      this.agencyService.checkAccountRightAgainstAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {
        if (data)
          this.accountRight = true;


      });
      if (req === 'save') {
        this.router.navigateByUrl("/flightSearch")
      }

    } catch (e) { console.log(e) }
  }//new added
  RevenueRightsBackClick() {
    this.revenueRightsComplete = false;
    this.managerInfoComplete = true;
    this.stepNine = false;
  }
  //new added
  revenueRightsClickTab() {

    this.managerInfoComplete = false;
    this.revenueRightsComplete = true;
    this.stepNine = true;
  }

  CheckManagerValiations(): boolean {
    try {
      if (this.managerList.length > 0) {
        for (let k = 0; k < this.managerList.length; k++) {
          let list = this.managerList[k];
          if (list.userId <= 0 || list.userId == undefined || list.userId == null) {
            document.getElementById(`managerNameInput${k}`).classList.add("newRequired-BoxColor");
            /*   label id here*/
            document.getElementById(`labelManagerName${k}`).style.color = "red";
            /*   message id here*/
            document.getElementById(`requiredManagerName${k}`).innerHTML = "Required Manager";
            setTimeout(function () {

              document.getElementById(`managerNameInput${k}`).classList.remove("newRequired-BoxColor");
              document.getElementById(`labelManagerName${k}`).style.color = "";
              document.getElementById(`requiredManagerName${k}`).innerHTML = "";
            }
              , 8000);
            return;

          }
          if (list.managerEmailAddress == null || list.managerEmailAddress == undefined || list.managerEmailAddress == "") {
            document.getElementById(`tbmanagerEmail${k}`).classList.add("newRequired-BoxColor");
            /*   label id here*/
            document.getElementById(`labelmanagerEmail${k}`).style.color = "red";
            /*   message id here*/
            document.getElementById(`requiredmanagerEmail${k}`).innerHTML = "Required Email";
            setTimeout(function () {

              document.getElementById(`tbmanagerEmail${k}`).classList.remove("newRequired-BoxColor");
              document.getElementById(`labelmanagerEmail${k}`).style.color = "";
              document.getElementById(`requiredmanagerEmail${k}`).innerHTML = "";
            }
              , 8000);
            return;

          }
          if (list.managerPhone == undefined || list.managerPhone == "" || list.managerPhone == null) {
            document.getElementById(`tbManagerPhone${k}`).classList.add("newRequired-BoxColor");
            /*   label id here*/
            document.getElementById(`labelManagerPhone${k}`).style.color = "red";
            /*   message id here*/
            document.getElementById(`requiredManagerPhone${k}`).innerHTML = "Required Mobile No";
            setTimeout(function () {

              document.getElementById(`tbManagerPhone${k}`).classList.remove("newRequired-BoxColor");
              document.getElementById(`labelManagerPhone${k}`).style.color = "";
              document.getElementById(`requiredManagerPhone${k}`).innerHTML = "";
            }
              , 8000);
            return;

          }




        }

      }

    }
    catch (e) {
      console.log(e);
    }
  }
  removeManager(i) {
    try {
      if (this.ManagersValidationIndex == i) {
        this.ManagersValidation = false;
      }
      this.loaderVar = true;
      if (this.managerList[i].managerId != 0) {
        this.agencyService.DeleteManager(this.managerList[i].managerId).subscribe(data => {
          if (data == true) {
            this.managerList.splice(i, 1);
            this.loaderVar = false;
          }
          else {
            this.loaderVar = false;

            document.getElementById("ManagerDetailsBtn").removeAttribute('disabled');
            document.getElementById("ManagerDetailsBtn").style.background = "";
            document.getElementById("ManagerDetailsBackBtn").style.display = "block";
          }

        })
      }
      else {
        if (this.managerList[i].managerId == 0) {
          this.managerList.splice(i, 1);
          document.getElementById("ManagerDetailsBtn").removeAttribute('disabled');
          document.getElementById("ManagerDetailsBtn").style.background = "";
          document.getElementById("ManagerDetailsBackBtn").style.display = "block";
        }
        this.loaderVar = false;
      }

    } catch (e) {
      console.log(e);
    }
  }
  AddManager() {
    try {
      let obj = new ManagerProperties();
      this.managerList.push(obj);
    } catch (e) {
      console.log(e);
    }
  }
  adminrightifagencynot() {
    if (this.agencyObj.agencyRightObj.profileUpdate == false) {
      this.agencyObj.userObj.adminUser.profileUpdate = false;
    }
    if (this.agencyObj.agencyRightObj.beneficiaryAccount == false) {
      this.agencyObj.userObj.adminUser.beneficiaryAccount = false;

    }
    if (this.agencyObj.agencyRightObj.paymentProcess == false) {
      this.agencyObj.userObj.adminUser.paymentProcess = false;
      this.agencyObj.userObj.adminUser.addPayment = false;
      this.agencyObj.userObj.adminUser.approvePayment = false;
    }

    if (this.agencyObj.agencyRightObj.creditLimit == false) {
      this.agencyObj.userObj.adminUser.creditLimit = false;
    }
    if (this.agencyObj.agencyRightObj.notifications == false) {
      this.agencyObj.userObj.adminUser.notifications = false;
    }
    if (this.agencyObj.agencyRightObj.revenueManagement == false) {
      this.agencyObj.userObj.adminUser.revenueManagement = false;
    }
    if (this.agencyObj.agencyRightObj.reportsManagement == false) {
      this.agencyObj.userObj.adminUser.reportsManage = false;
      for (let o = 0; o < this.reportTypesUser.length; o++) {
        this.reportTypesUser[o].status = false;
      }

    }
    if (this.agencyObj.agencyRightObj.offlineRequest == false) {
      this.agencyObj.userObj.adminUser.offlineRequest = false;
      this.agencyObj.userObj.adminUser.offlineBooking = false;
      this.agencyObj.userObj.adminUser.offlineDealsByCMS = false;
      this.agencyObj.userObj.adminUser.offlineRefund = false;
      this.agencyObj.userObj.adminUser.offlineTicket = false;
      this.agencyObj.userObj.adminUser.offlineVoid = false;
    }
    if (this.agencyObj.agencyRightObj.offlineSettings == false) {
      this.agencyObj.userObj.adminUser.offlineSettings = false;
    }
    if (this.agencyObj.agencyRightObj.supplierManagement == false) {
      this.agencyObj.userObj.adminUser.supplierManagement = false;
    }
    if (this.agencyObj.agencyRightObj.accountManagement == false) {
      this.agencyObj.userObj.adminUser.accountManagement = false;
      this.agencyObj.userObj.adminUser.agencyManagement = false;
      this.agencyObj.userObj.adminUser.branchManagement = false;
      this.agencyObj.userObj.adminUser.account = false;
      this.agencyObj.userObj.adminUser.users = false;
      this.agencyObj.userObj.adminUser.logs = false;
      this.agencyObj.userObj.adminUser.currency = false;
    }
    if (this.agencyObj.agencyRightObj.bookings == false) {
      this.agencyObj.userObj.adminUser.bookings = false;
      this.agencyObj.userObj.adminUser.searchBookings = false;
      this.agencyObj.userObj.adminUser.viewBookings = false;
      this.agencyObj.userObj.adminUser.viewSubAgentBookings = false;
      this.agencyObj.userObj.adminUser.issueTicket = false;
      this.agencyObj.userObj.adminUser.cancelPNR = false;
      this.agencyObj.userObj.adminUser.refund = false;
      this.agencyObj.userObj.adminUser.importPNR = false;
      this.agencyObj.userObj.adminUser.exchangeTicket = false;
      this.agencyObj.userObj.adminUser.quotations = false;
      this.agencyObj.userObj.adminUser.fareRules = false;
      this.agencyObj.userObj.adminUser.voidTicket = false;
    }
    if (this.agencyObj.agencyRightObj.cms == false) {
      this.agencyObj.userObj.adminUser.cms = false;
    }
    if (this.agencyObj.agencyRightObj.dashboard == false) {
      this.agencyObj.userObj.adminUser.dashboard = false;
    }
    if (this.agencyObj.agencyRightObj.currency == false) {
      this.agencyObj.userObj.adminUser.currency = false;
    }



    if (this.agencyObj.agencyRightObj.accountManagement == false) {
      this.agencyObj.userObj.adminUser.accountManagement = false;
      this.agencyObj.userObj.adminUser.users = false;
      this.agencyObj.userObj.adminUser.account = false;
      this.agencyObj.userObj.adminUser.agencyManagement = false;
      this.agencyObj.userObj.adminUser.branchManagement = false;

    }
    if (this.agencyObj.agencyRightObj.users == false) {
      this.agencyObj.userObj.adminUser.users = false;


    }
    if (this.agencyObj.agencyRightObj.agencyManagement == false) {
      this.agencyObj.userObj.adminUser.agencyManagement = false;
    }
    if (this.agencyObj.agencyRightObj.account == false) {
      this.agencyObj.userObj.adminUser.account = false;
    }
    if (this.agencyObj.agencyRightObj.branchManagement == false) {
      this.agencyObj.userObj.adminUser.branchManagement = false;

    }
    if (this.agencyObj.agencyRightObj.companyMasterRight == false) {
      this.agencyObj.userObj.adminUser.companyMasterRight = false;
    }
  }
  /*--------------------------- agency branch rights assign here this two function--------------------------*/
  AgencyRightsClick = (req: string): boolean => {
    /* if (this.AgencyRightsCheckValiations()) {*/
    try {
      if (this.agencyObj.maximumChildAgencies > 0 || this.agencyObj.maximumChildBranches > 0) {

        if (this.agencyObj.agencyRightObj.issueTicket == false) {
          document.getElementById("AgencyRightError").innerHTML = "**Please Give Ticket Issuance Rights";
          setTimeout(() => {
            document.getElementById("AgencyRightError").innerHTML = "";
          }, 5000);
          return;
        }
      }
      let userId = 0;
      if (localStorage.getItem("UserId") != undefined && localStorage.getItem("UserId") != null) {
        userId = Number(localStorage.getItem("UserId"))
        if (userId != 0) {

          if (this.agencyObj.agencyId != "" && this.agencyObj.agencyId != undefined) {
            this.agencyObj.agencyRightObj.agencyId = this.agencyObj.agencyId;
            if (this.agencyObj.agencyRightObj.agencyRightId == 0 || this.agencyObj.userObj.userId == null) {
              this.agencyObj.agencyRightObj.creationUser = userId;
              this.agencyObj.agencyRightObj.reportTypesRights = this.reportTypesAgency;
              this.agencyService.CreateAgencyRights(this.agencyObj.agencyRightObj).subscribe((data) => {
                if (data.isSave == true) {

                  this.reportTypesAgency = data.reportTypesRights
                  for (let k = 0; k < this.reportTypesAgency.length; k++) {
                    for (let j = 0; j < this.reportTypesUser.length; j++) {
                      if (this.reportTypesUser[j].reportTypes == this.reportTypesAgency[k].reportTypes) {
                        this.reportTypesUser[j].statusForUser = this.reportTypesAgency[k].status;
                        this.reportTypesUser[j].status = this.reportTypesAgency[k].status;
                      }
                    }
                  }
                  this.GetparentAgencyRights();
                  this.adminrightifagencynot();
                  this.agencyRightsComplete = false;
                  this.adminInfoComplete = true;
                  this.stepFour = true;
                }
                else {
                  this.agencyObj.agencyRightObj.agencyRightId = 0;
                  $("#lblerrormsg").show();
                  document.getElementById("lblerrormsg").innerHTML = "Something went wrong on Creating Agency Rights."
                  $("#lblerrormsg").delay(5000).hide(10);
                }
              });
            }
            else {
              this.agencyObj.agencyRightObj.modifyUser = userId;
              this.agencyObj.agencyRightObj.reportTypesRights = this.reportTypesAgency;
              this.agencyService.UpdateAgencyRights(this.agencyObj.agencyRightObj).subscribe((data) => {
                if (data.isSave == true) {

                  this.reportTypesAgency = data.reportTypesRights
                  for (let k = 0; k < this.reportTypesAgency.length; k++) {
                    for (let j = 0; j < this.reportTypesUser.length; j++) {
                      if (this.reportTypesUser[j].reportTypes == this.reportTypesAgency[k].reportTypes) {
                        this.reportTypesUser[j].statusForUser = this.reportTypesAgency[k].status;
                        this.reportTypesUser[j].status = this.reportTypesAgency[k].status;
                      }
                    }
                  }
                  this.GetparentAgencyRights();
                  this.adminrightifagencynot();
                  this.agencyRightsComplete = false;
                  this.adminInfoComplete = true;
                  this.stepFour = true;
                }
                else {
                  this.agencyObj.agencyRightObj.agencyRightId = 0;
                  $("#lblerrormsg").show();
                  document.getElementById("lblerrormsg").innerHTML = "Something went wrong on Updating Agency Rights"
                  $("#lblerrormsg").delay(5000).hide(10);
                }
              });
            }
          }
        }
      }
      if (this.agencyObj.immediateParent != "AG01") {
        this.backsystemOfficeProperties[0].selectSingleBackSystemCustomer = this.backsystemOfficeProperties[0].customerCodesList[0].customerCode
        this.backsystemOfficeProperties[0].backSystemCompanyId = this.backSystemCompanies[0].companyId
        this.backSystemInfoSave('Next Step');
        this.agencyRightsComplete = false;
        this.adminInfoComplete = true;
        this.stepFour = true;
      }

      if (req === 'save') {
        this.router.navigateByUrl("/flightSearch")
      } else {
        this.backsystemgetinfo(this.agencyObj.agencyId);
      }
    }
    catch (e) {
      console.log(e);
    }

  }
  SelectFileUpload(e) {
    try {
      this.checkImgUpload = false;

      let files = e.target.files;
      if (files.length == 0)
        return;
      else {
        this.disablefileupload = true;
        let response = "";
        let responseSplit;
        let firstResponsePart;
        let secondResponsePart;
        let responseCheck;
        var fileToUpload = files.item(0)
        let reader = new FileReader();
        reader.onload = (event: any) => {
          this.imageSource = event.target.result;
        }
        reader.readAsDataURL(fileToUpload);

        const formData = new FormData();
        for (let file of files) {
          formData.append(file.name, file);
        }
        const uploadReq = new HttpRequest('POST', this.baseUrl + '/AgencyMaster/UploadFile', formData, {
          reportProgress: true,
        });
        this.http.request(uploadReq).subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progress = Math.round(100 * event.loaded / event.total);
          }
          else if (event.type === HttpEventType.Response) {
            response = event.body.toString();
            responseSplit = response.split("\"");
            firstResponsePart = responseSplit[0];
            secondResponsePart = firstResponsePart.split("/,/");
            responseCheck = secondResponsePart[0];
            if (responseCheck == "Uploaded") {
              this.agencyObj.logoFileName = secondResponsePart[2];
              this.agencyObj.logoFilePath = secondResponsePart[1];
              this.disablefileupload = false;
              this.checkImgUpload = true;
              $("#lbluploadmsg").show();
              document.getElementById("lbluploadmsg").innerHTML = "File Uploaded."
              $("#lbluploadmsg").delay(4000).hide(10);
            }

            else {
              this.disablefileupload = false;
              this.checkImgUpload = false;
              $("#lblerrormsg").show();
              document.getElementById("lblerrormsg").innerHTML = "Failed Upload File. Please Try Later."
              $("#lblerrormsg").delay(5000).hide(10);
              return false;
            }
          }
        });

      }


    }
    catch (e) {
      console.log(e)
    }

  }
  adminInfoClick = (req: string): boolean => {
    try {
      if (this.CheckAdminValidations()) {
        this.agencyObj.userObj.password = this.agencyObj.userObj.password ? this.agencyObj.userObj.password : "";
        if (this.agencyObj.userObj.isAgencyAdmin == false) {
          this.agencyObj.userObj.adminUser = new UserAdminControlRightsProperties();
        }
        else {
          if (this.agencyObj.userObj.adminUser.paymentProcess == false) {
            this.agencyObj.userObj.adminUser.addPayment = false;
            this.agencyObj.userObj.adminUser.approvePayment = false;
            this.agencyObj.userObj.adminUser.deletePayment = false;
          }
          if (this.agencyObj.userObj.adminUser.accountManagement == false) {
            this.agencyObj.userObj.adminUser.account = false;
            this.agencyObj.userObj.adminUser.users = false;
            this.agencyObj.userObj.adminUser.logs = false;
            this.agencyObj.userObj.adminUser.currency = false;
          }
          if (this.agencyObj.userObj.adminUser.bookings == false) {
            this.agencyObj.userObj.adminUser.searchBookings = false;
            this.agencyObj.userObj.adminUser.viewBookings = false;
            this.agencyObj.userObj.adminUser.updateBookings = false;
          }
        }

        if (this.agencyObj.userObj.isAgent == false) {
          this.agencyObj.userObj.agentUser = new UserAgentRightsProperties();
        }
        else {
          if (this.agencyObj.userObj.agentUser.book == false) {
            this.agencyObj.userObj.agentUser.newBookings = false;
            this.agencyObj.userObj.agentUser.myBookings = false;
            this.agencyObj.userObj.agentUser.searchBookings = false;
          }
        }

        let param = "";
        let isAgency;
        let userId = 0;
        if (localStorage.getItem("UserId") != undefined && localStorage.getItem("UserId") != null) {
          userId = Number(localStorage.getItem("UserId"))
          if (userId != 0) {
            if (this.agencyObj.agencyId != "" && this.agencyObj.agencyId != undefined) {

              this.agencyObj.userObj.agency_branchId = this.agencyObj.agencyId;
              if (this.agencyObj.userObj.userId == 0 || this.agencyObj.userObj.userId == null ||
                this.agencyObj.userObj.userId == undefined) {
                isAgency = false;
                param = this.agencyObj.agencyId;
                this.agencyService.CheckUsersLimit(param, isAgency).subscribe((data) => {
                  if (data != null && data != undefined) {
                    if (data == -1) {
                      $("#lblerrormsg").show();
                      document.getElementById("lblerrormsg").innerHTML = "Maximum User Limit Reached."
                      $("#lblerrormsg").delay(5000).hide(10);
                    }
                    else {
                      //01-feb-24
                      if (this.CheckUserEmail() == true) {
                        return false;
                      }
                      //end
                      if (this.CheckLoginName() == false) {
                        return;
                      }
                      this.agencyObj.userObj.creationUser = userId;
                      this.agencyObj.userObj.branchId = "";
                      this.reportTypesUser[0].requestStatus = true;
                      this.agencyObj.userObj.reportTypesRightsUser = this.reportTypesUser;
                      this.agencyService.CreateAdminUser(this.agencyObj.userObj).subscribe((data) => {
                        if (data != 0 && data != null) {
                          this.agencyObj.userObj.userId = data;
                          this.reportTypesUser[0].requestStatus = false;
                          this.adminInfoComplete = false;
                          this.managerInfoComplete = true;
                          this.stepFive = true;
                          this.GetUsers();
                          this.GetParentManagers(this.agencyObj.immediateParent, this.agencyObj.agencyId);
                        }
                        else {
                          this.agencyObj.userObj.userId = 0;

                          $("#lblerrormsg").show();
                          document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
                          $("#lblerrormsg").delay(5000).hide(10);
                        }
                      });

                    }
                  }
                  else {
                    $("#lblerrormsg").show();
                    document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
                    $("#lblerrormsg").delay(5000).hide(10);
                  }
                });
              }
              else {
                //01-feb-24
                if (this.CheckUserEmail() == true) {
                  return false;
                }
                else {
                  //end
                  this.agencyObj.userObj.modifyUser = userId;
                  this.agencyObj.userObj.reportTypesRightsUser = this.reportTypesUser;
                  this.reportTypesUser[0].requestStatus = true;
                  this.agencyService.UpdateAdminUser(this.agencyObj).subscribe((r) => {
                    if (r == true) {
                      this.reportTypesUser[0].requestStatus = false;
                      this.adminInfoComplete = false;
                      this.managerInfoComplete = true;
                      this.stepFive = true;
                      this.GetUsers();
                      this.GetParentManagers(this.agencyObj.immediateParent, this.agencyObj.agencyId);
                    }
                    else {
                      $("#lblerrormsg").show();
                      document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
                      $("#lblerrormsg").delay(5000).hide(10);
                    }
                  });
                }
              }
            }
          }
        }



        if (req === 'save') {
          this.router.navigateByUrl("/flightSearch")
        }
      }

    } catch (e) {
      console.log(e)
    }
  }


  //01-Feb-24 new Function
  userEmailExist: boolean;
  public CheckUserEmail = (): boolean => {
    if (this.agencyObj.userObj.email != "" && this.agencyObj.userObj.email != null && this.agencyObj.userObj.email != undefined) {
      this.agencyService.CheckUserEmailValidation(this.agencyObj.userObj.email, this.agencyObj.userObj.userId).subscribe((data) => {
        if (data == false) {
          this.userEmailExist = false;
        }
        else {
          document.getElementById("requireduseremail").innerHTML = "Email already exsist choose another one";
          setTimeout(function () {
            document.getElementById("requireduseremail").innerHTML = "";
          }
            , 6000);
          this.userEmailExist = true;
        }
      });

      return this.userEmailExist;
    }


  }
  ///*----------------------adminuserRight procedure start here------------------------------*/
  //adminInfoClick=(req:string):void=> {
  //  try {
  //    if (this.CheckAdminValidations()) {
  //      if (this.agencyObj.userObj.isAgencyAdmin == false) {
  //        this.agencyObj.userObj.adminUser = new UserAdminControlRightsProperties();
  //      }
  //      else {
  //        if (this.agencyObj.userObj.adminUser.paymentProcess == false) {
  //          this.agencyObj.userObj.adminUser.addPayment = false;
  //          this.agencyObj.userObj.adminUser.approvePayment = false;
  //          this.agencyObj.userObj.adminUser.deletePayment = false;
  //        }
  //        if (this.agencyObj.userObj.adminUser.accountManagement == false) {
  //          this.agencyObj.userObj.adminUser.account = false;
  //          this.agencyObj.userObj.adminUser.users = false;
  //          this.agencyObj.userObj.adminUser.logs = false;
  //          this.agencyObj.userObj.adminUser.currency = false;
  //        }
  //        if (this.agencyObj.userObj.adminUser.bookings == false) {
  //          this.agencyObj.userObj.adminUser.searchBookings = false;
  //          this.agencyObj.userObj.adminUser.viewBookings = false;
  //          this.agencyObj.userObj.adminUser.updateBookings = false;
  //        }
  //      }

  //      if (this.agencyObj.userObj.isAgent == false) {
  //        this.agencyObj.userObj.agentUser = new UserAgentRightsProperties();
  //      }
  //      else {
  //        if (this.agencyObj.userObj.agentUser.book == false) {
  //          this.agencyObj.userObj.agentUser.newBookings = false;
  //          this.agencyObj.userObj.agentUser.myBookings = false;
  //          this.agencyObj.userObj.agentUser.searchBookings = false;
  //        }
  //      }

  //      let param = "";
  //      let isAgency;
  //      let userId = 0;
  //      if (localStorage.getItem("UserId") != undefined && localStorage.getItem("UserId") != null) {
  //        userId = Number(localStorage.getItem("UserId"))
  //        if (userId != 0) {
  //          if (this.agencyObj.agencyId != "" && this.agencyObj.agencyId != undefined) {

  //            this.agencyObj.userObj.agency_branchId = this.agencyObj.agencyId;
  //            if (this.agencyObj.userObj.userId == 0 || this.agencyObj.userObj.userId == null ||
  //              this.agencyObj.userObj.userId == undefined) {
  //              isAgency = false;
  //              param = this.agencyObj.agencyId;
  //              this.agencyService.CheckUsersLimit(param, isAgency).subscribe((data) => {
  //                if (data != null && data != undefined) {
  //                  if (data == -1) {
  //                    $("#lblerrormsg").show();
  //                    document.getElementById("lblerrormsg").innerHTML = "Maximum User Limit Reached."
  //                    $("#lblerrormsg").delay(5000).hide(10);
  //                  }
  //                  else {
  //                    if (this.CheckLoginName() == false) {
  //                      return;
  //                    }
  //                    this.agencyObj.userObj.creationUser = userId;
  //                    this.agencyObj.userObj.branchId = "";
  //                    this.reportTypesUser[0].requestStatus = true;
  //                    this.agencyObj.userObj.reportTypesRightsUser = this.reportTypesUser;
  //                    this.agencyService.CreateAdminUser(this.agencyObj.userObj).subscribe((data) => {
  //                      if (data != 0 && data != null) {
  //                        this.agencyObj.userObj.userId = data;
  //                        this.reportTypesUser[0].requestStatus = false;
  //                        this.adminInfoComplete = false;
  //                        this.managerInfoComplete = true;
  //                        this.stepFive = true;
  //                        this.GetUsers();
  //                        this.GetParentManagers(this.agencyObj.immediateParent, this.agencyObj.agencyId);
  //                      }
  //                      else {
  //                        this.agencyObj.userObj.userId = 0;

  //                        $("#lblerrormsg").show();
  //                        document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
  //                        $("#lblerrormsg").delay(5000).hide(10);
  //                      }
  //                    });

  //                  }
  //                }
  //                else {
  //                  $("#lblerrormsg").show();
  //                  document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
  //                  $("#lblerrormsg").delay(5000).hide(10);
  //                }
  //              });
  //            }
  //            else {
  //              this.agencyObj.userObj.modifyUser = userId;
  //              this.agencyObj.userObj.reportTypesRightsUser = this.reportTypesUser;
  //              this.reportTypesUser[0].requestStatus = true;
  //              this.agencyService.UpdateAdminUser(this.agencyObj).subscribe((r) => {
  //                if (r == true) {
  //                  this.reportTypesUser[0].requestStatus = false;
  //                  this.adminInfoComplete = false;
  //                  this.managerInfoComplete = true;
  //                  this.stepFive = true;
  //                  this.GetUsers();
  //                  this.GetParentManagers(this.agencyObj.immediateParent, this.agencyObj.agencyId);
  //                }
  //                else {
  //                  $("#lblerrormsg").show();
  //                  document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
  //                  $("#lblerrormsg").delay(5000).hide(10);
  //                }
  //              });
  //            }
  //          }
  //        }
  //      }



  //      if (req === 'save') {
  //        this.router.navigateByUrl("/flightSearch")
  //      }
  //    }

  //  } catch (e) {
  //    console.log(e)
  //  }
  //}
  ChangeGetSelectedBackSystemCustomers(companyId: number) {
    if (this.agencyObj.userObj.backSystemCompanyId != 0) {
      this.custCode.handleClearClick();
    }
    this.GetSelectedBackSystemCustomers(companyId);
  }
  GetSelectedBackSystemCustomers(companyId: number) {
    if (companyId != null && companyId != undefined && companyId > 0) {
      let companyURL = "";
      for (let i = 0; i < this.backSystemCompanies.length; i++) {
        if (companyId == this.backSystemCompanies[i].companyId) {
          companyURL = this.backSystemCompanies[i].companyURL;
          this.loaderVar = true;
          break;
        }

      }
      var req = new UrlRequest();
      req.request = companyURL;
      this.agencyService.GetCustomerCodeByID(req).subscribe((data) => {
        this.codes = data;
        this.loaderVar = false;
        this.onChnageCode = [];
        this.backSystemAllList
        for (let i = 0; i < this.backSystemAllList.length; i++) {
          if (this.backSystemAllList[i].backSystemCompanyId == companyId) {
            for (let j = 0; j < this.backSystemAllList[i].backSystemAll.length; j++) {
              for (let k = 0; this.codes.length; k++) {
                if (this.backSystemAllList[i].backSystemAll[j].backSystemCompanyCustomer == this.codes[k].customerCode) {
                  this.onChnageCode.push(this.codes[k]);
                  break;
                }
              }
            }
            break;
          }
        }
      });
    }

  }
  userLimit() {
    if (this.agencyObj.agencyId != "AG01") {
      if (this.agencyObj.immediateParent == "" || this.agencyObj.immediateParent == undefined || this.agencyObj.immediateParent == null) {
        this.immediateParentForuser = this.agencyObj.parentAgency;
      }
      this.agencyService.UserLimitCheck(this.agencyObj.agencyId, this.immediateParentForuser, this.agencyObj.maximumUsers).subscribe(data => {
        //console.log(data)
        if (data == false) {
          this.userlimitreached = true;
          document.getElementById("tbMaxUsers").classList.add("newRequired-BoxColor");
          document.getElementById("labelmaxuser").style.color = "red";
          document.getElementById("requiredusermax").innerHTML = "Maximum Limit Reached"

        }
        else {
          this.userlimitreached = false;
          document.getElementById("tbMaxUsers").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmaxuser").style.color = "";
          document.getElementById("requiredusermax").innerHTML = "";

        }
      })
    }
    else {
      this.userlimitreached = false;
    }

  }
  CheckParentCredit(value) {
    try {

      let param = "";
      let agencyID
      if (this.agencyObj.immediateParent == "" || this.agencyObj.immediateParent == null
        || this.agencyObj.immediateParent == this.agencyObj.parentAgency) {
        this.isAgency = true;
      }
      else
        this.isAgency = false;
      if (this.isAgency == true)
        param = this.agencyObj.parentAgency;
      else
        param = this.agencyObj.immediateParent;
      if (this.agencyObj.agencyId == "") {
        agencyID = "AG";

      }
      else {
        agencyID = this.agencyObj.agencyId
      }
      if (agencyID != "AG01") {




        if (this.backSystemCreditLimit.creditLimit > 0) {
          this.agencyService.CheckParentCreditLimit(param, this.isAgency, agencyID).subscribe((data) => {
            this.creditLimitChecking = data;

            if (this.backSystemCreditLimit.creditLimit != 0 && value > this.backSystemCreditLimit.creditLimit) {
              this.creditCheck = true;
              document.getElementById("tbCredit").classList.add("newRequired-BoxColor");
              /*   label id here*/
              document.getElementById("labelcredit").style.color = "red";
              /*   message id here*/
              document.getElementById("requiredcreditlimit").innerHTML = "Credit Should less from Parent";
              setTimeout(function () {

                document.getElementById("tbCredit").classList.remove("newRequired-BoxColor");
                document.getElementById("labelcredit").style.color = "";
                document.getElementById("requiredcreditlimit").innerHTML = "";
              }
                , 8000);

              return false;
            }
            else {
              this.creditCheck = false;
            }

            if (value < this.pendingCreditChange) {

              let newValue: number = 0;
              newValue = this.pendingCreditChange - value;

              if (this.creditLimitChecking.returnPendingCredit - newValue < 0) {
                this.pendingCreditDecreased = true;
                document.getElementById("tbCredit").classList.add("newRequired-BoxColor");
                /*   label id here*/
                document.getElementById("labelcredit").style.color = "red";
                /*   message id here*/
                document.getElementById("requiredcreditlimit").innerHTML = "You cannot decrease Credit Limit";
                setTimeout(function () {

                  document.getElementById("tbCredit").classList.remove("newRequired-BoxColor");
                  document.getElementById("labelcredit").style.color = "";
                  document.getElementById("requiredcreditlimit").innerHTML = "";
                }
                  , 8000);

                return false;
              }
              else {
                this.pendingCreditDecreased = false;
              }
            }
            else {
              this.pendingCreditDecreased = false;
            }
          })
        }
      }
      else {

        this.creditCheck = false;
      }
    }
    catch (e) { }
  }


  GetLoginBackSystemCredit = (): BackSystemCreditLimitProperties => {
    this.backSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
    this.backSystemCompanyCustomer = localStorage.getItem("BackSystemCompanyCustomer");
    this.ImmediateParent = localStorage.getItem("ImmediateParent");
    if (this.ImmediateParent == "AG01") {
      if ((this.backSystemCompanyId != undefined && this.backSystemCompanyId != null && this.backSystemCompanyId > 0)
        && (this.backSystemCompanyCustomer != undefined && this.backSystemCompanyCustomer != null && this.backSystemCompanyCustomer != "")) {
        for (let i = 0; i < this.backSystemCompanies.length; i++) {
          if (this.backSystemCompanyId == this.backSystemCompanies[i].companyId) {
            this.backSystemCreditRequest.companyURL = this.backSystemCompanies[i].companyURL;
            this.backSystemCreditRequest.companyCustomer = this.backSystemCompanyCustomer;
            this.agencyService.GetBackSystemCredit(this.backSystemCreditRequest).subscribe(data => {
              //   console.log(data)
              if (data != null) {

                this.backSystemCreditLimit = data;
                // this.backSystemCreditLimit.creditLimit = this.backSystemCreditLimit.creditLimit - this.backSystemCreditLimit.creditOutstanding;
              }


            })
            break;
          }
        }

      }
    }
    return this.backSystemCreditLimit;
  }

  beneficiaryAccountCheckboxChange(e) {
    if (e.target.checked == false) {
      this.agencyObj.agencyRightObj.approvePayment = false;
      this.agencyObj.userObj.adminUser.approvePayment = false;
    }
  }
  PaymentProcessCheckboxChange(e) {
    if (e.target.checked == false) {
      this.agencyObj.agencyRightObj.paymentProcess = false;
      this.agencyObj.agencyRightObj.addPayment = false;
      this.agencyObj.agencyRightObj.approvePayment = false;
      this.agencyObj.userObj.adminUser.paymentProcess = false;
      this.agencyObj.userObj.adminUser.addPayment = false;
      this.agencyObj.userObj.adminUser.approvePayment = false;
    }
  }
  PaymentProcessAdminCheckboxChange(e) {
    if (e.target.checked == false) {
      this.agencyObj.userObj.adminUser.paymentProcess = false;
      this.agencyObj.userObj.adminUser.addPayment = false;
      this.agencyObj.userObj.adminUser.approvePayment = false;
    }
  }
  CreditLimitCheckboxChange(e) {
    if (e.target.checked == false) {
      this.agencyObj.agencyRightObj.creditLimit = false;
      this.agencyObj.userObj.adminUser.creditLimit = false;
    }
  }
  RevenueManagementCheckboxChange(e) {
    if (e.target.checked == false) {
      this.agencyObj.agencyRightObj.revenueManagement = false;
      this.agencyObj.userObj.adminUser.revenueManagement = false;
    }
  }

  offlineRequestCheckboxChange(e) {
    if (e.target.checked == false) {
      this.agencyObj.agencyRightObj.offlineRequest = false;
      this.agencyObj.agencyRightObj.offlineBooking = false;
      this.agencyObj.agencyRightObj.offlineTicket = false;
      this.agencyObj.agencyRightObj.offlineVoid = false;
      this.agencyObj.agencyRightObj.offlineRefund = false;
      this.agencyObj.agencyRightObj.offlineDealsByCMS = false;

      this.agencyObj.userObj.adminUser.offlineRequest = false;
      this.agencyObj.userObj.adminUser.offlineBooking = false;
      this.agencyObj.userObj.adminUser.offlineTicket = false;
      this.agencyObj.userObj.adminUser.offlineVoid = false;
      this.agencyObj.userObj.adminUser.offlineRefund = false;
      this.agencyObj.userObj.adminUser.offlineDealsByCMS = false;
    }
  }
  offlineRequestAdminCheckboxChange(e) {
    if (e.target.checked == false) {
      this.agencyObj.userObj.adminUser.offlineRequest = false;
      this.agencyObj.userObj.adminUser.offlineBooking = false;
      this.agencyObj.userObj.adminUser.offlineTicket = false;
      this.agencyObj.userObj.adminUser.offlineVoid = false;
      this.agencyObj.userObj.adminUser.offlineRefund = false;
      this.agencyObj.userObj.adminUser.offlineDealsByCMS = false;
    }
  }
  offlineSettingsCheckboxChange(e) {
    if (e.target.checked == false) {
      this.agencyObj.agencyRightObj.offlineSettings = false;
      this.agencyObj.userObj.adminUser.offlineSettings = false;
    }
  }
  supplierManagementCheckboxChange(e) {
    if (e.target.checked == false) {
      this.agencyObj.agencyRightObj.supplierManagement = false;
      this.agencyObj.userObj.adminUser.supplierManagement = false;
    }
  }
  accountManagementCheckboxChange(e) {
    if (e.target.checked == false) {
      this.agencyObj.agencyRightObj.accountManagement = false;
      this.agencyObj.agencyRightObj.users = false;
      this.agencyObj.agencyRightObj.account = false;
      this.agencyObj.agencyRightObj.agencyManagement = false;
      this.agencyObj.agencyRightObj.branchManagement = false;

      this.agencyObj.userObj.adminUser.accountManagement = false;
      this.agencyObj.userObj.adminUser.users = false;
      this.agencyObj.userObj.adminUser.account = false;
      this.agencyObj.userObj.adminUser.agencyManagement = false;
      this.agencyObj.userObj.adminUser.branchManagement = false;

    }
  }
  accountManagementAdminCheckboxChange(e) {
    if (e.target.checked == false) {

      this.agencyObj.userObj.adminUser.accountManagement = false;
      this.agencyObj.userObj.adminUser.users = false;
      this.agencyObj.userObj.adminUser.account = false;
      this.agencyObj.userObj.adminUser.agencyManagement = false;
      this.agencyObj.userObj.adminUser.branchManagement = false;

    }
  }
  BookingsCheckboxChange(e) {
    if (e.target.checked == false) {
      this.agencyObj.agencyRightObj.searchBookings = false;
      this.agencyObj.agencyRightObj.viewBookings = false;
      this.agencyObj.agencyRightObj.viewSubAgentBookings = false;
      this.agencyObj.agencyRightObj.issueTicket = false;
      this.agencyObj.agencyRightObj.cancelPNR = false;
      this.agencyObj.agencyRightObj.refund = false;
      this.agencyObj.agencyRightObj.importPNR = false;
      this.agencyObj.agencyRightObj.exchange = false;
      this.agencyObj.agencyRightObj.quotations = false;
      this.agencyObj.agencyRightObj.fareRulesResult = false;
      this.agencyObj.agencyRightObj.voidTicket = false;

      this.agencyObj.userObj.adminUser.searchBookings = false;
      this.agencyObj.userObj.adminUser.viewBookings = false;
      this.agencyObj.userObj.adminUser.viewSubAgentBookings = false;
      this.agencyObj.userObj.adminUser.issueTicket = false;
      this.agencyObj.userObj.adminUser.cancelPNR = false;
      this.agencyObj.userObj.adminUser.refund = false;
      this.agencyObj.userObj.adminUser.exchangeTicket = false;
      this.agencyObj.userObj.adminUser.importPNR = false;
      this.agencyObj.userObj.adminUser.quotations = false;
      this.agencyObj.userObj.adminUser.fareRules = false;
      this.agencyObj.userObj.adminUser.voidTicket = false;

      this.agencyObj.userObj.adminUser.modifyBooking = false;
      this.agencyObj.agencyRightObj.modifyBooking = false;


    }
  }
  BookingsAdminCheckboxChange(e) {
    if (e.target.checked == false) {
      this.agencyObj.userObj.adminUser.searchBookings = false;
      this.agencyObj.userObj.adminUser.viewBookings = false;
      this.agencyObj.userObj.adminUser.viewSubAgentBookings = false;
      this.agencyObj.userObj.adminUser.issueTicket = false;
      this.agencyObj.userObj.adminUser.cancelPNR = false;
      this.agencyObj.userObj.adminUser.refund = false;
      this.agencyObj.userObj.adminUser.exchangeTicket = false;
      this.agencyObj.userObj.adminUser.importPNR = false;
      this.agencyObj.userObj.adminUser.quotations = false;
      this.agencyObj.userObj.adminUser.fareRules = false;
      this.agencyObj.userObj.adminUser.voidTicket = false;

      this.agencyObj.userObj.adminUser.modifyBooking = false;

    }
  }
  OnAgencyBranchChildChange() {
    if (this.agencyObj.maximumChildAgencies < 0) {
      this.agencyObj.maximumChildAgencies = 0;
    }
    if (this.agencyObj.maximumChildBranches < 0) {
      this.agencyObj.maximumChildBranches = 0;
    }
  }

  goToStep(stepNumber: number): void {
    localStorage.removeItem("isFromAgencyList");

    let checkingValueString: boolean = false;
    if (this.agencylistid != null && this.agencylistid != "" && this.agencylistid != undefined) {
      checkingValueString = true;
    }
    else {
      checkingValueString = false;
    }

    if (checkingValueString) {
      this.agencyInfoComplete = false;
      this.BackOfficeInfoComplete = false;
      this.managerInfoComplete = false;
      this.adminInfoComplete = false;
      this.settleModeComplete = false;
      this.logoInfoComplete = false;
      this.agencyRightsComplete = false;
      this.supplierRightsComplete = false;
      this.revenueRightsComplete = false;

      switch (stepNumber) {
        case 1:
          this.agencyInfoComplete = true;
          this.stepOne = true;
          this.stepTwo = false;
          this.stepThree = false;
          this.stepFour = false;
          this.stepFive = false;
          this.stepSix = false;
          this.stepNine = false;
          break;
        case 2:
          this.BackOfficeInfoComplete = true;
          this.backsystemOfficeProperties = [];
          if (this.agencyObj.agencyId == "AG01") {
            this.selectMultipleBackSystemCustomer = true;
          }
          else {
            this.selectMultipleBackSystemCustomer = false;
          }
          this.currencyCodeList$.subscribe(data => {
            const currencyList = data.find(id => id.currencyId === this.agencyObj.currency);
            const comapnyList = this.backSystemCompanies.filter(company =>
              currencyList.currencyName.includes(company.companyCurrency));
            this.backSystemCompanies = comapnyList;

          });
          this.backsystemgetinfo(this.agencyObj.agencyId);
          this.stepOne = true;
          this.stepTwo = true;
          this.stepThree = false;
          this.stepFour = false;
          this.stepFive = false;
          this.stepSix = false;
          this.stepNine = false;
          break;
        case 3:
          this.agencyService.AgencyBranchLimitationRights(this.agencyObj.agencyId).subscribe((data) => {
            this.AgencyBranchLimitationRights = data;
          });
          this.agencyRightsComplete = true;
          this.stepOne = true;
          this.stepTwo = true;
          this.stepThree = true;
          this.stepFour = false;
          this.stepFive = false;
          this.stepSix = false; this.stepNine = false;
          break;
        case 4:
          this.adminInfoComplete = true;
          this.agencyService.AgencyBranchLimitationRights(this.agencyObj.agencyId).subscribe((data) => {
            this.AgencyBranchLimitationRights = data;
          });
          this.AgencyRightsClickTab();
          if (this.agencyObj.immediateParent != "AG01") {
            this.backsystemgetinfo(this.agencyObj.immediateParent);
          }
          else {

            this.backsystemgetinfo(this.agencyObj.agencyId);
          }

          this.stepOne = true;
          this.stepTwo = true;
          this.stepThree = true;
          this.stepFour = true;
          this.stepFive = false;
          this.stepSix = false; this.stepNine = false;
          break;
        case 5:
          this.managerInfoComplete = true;
          this.reportTypesUser[0].requestStatus = false;
          this.GetUsers();
          this.GetParentManagers(this.agencyObj.immediateParent, this.agencyObj.agencyId);
          this.stepOne = true;
          this.stepTwo = true;
          this.stepThree = true;
          this.stepFour = true;
          this.stepFive = true;
          this.stepSix = false; this.stepNine = false;
          break;
        case 6:
          this.supplierRightsComplete = true;
          this.supplierRightsClickTab();
          this.stepSix = true;
          this.stepOne = true;
          this.stepTwo = true;
          this.stepThree = true;
          this.stepFour = true;
          this.stepFive = true; this.stepNine = false;
          break;
        case 7:
          this.revenueRightsComplete = true;
          localStorage.setItem("isFromAgencyList", "True");
          this.revenueRightsClickTab();
          this.stepSix = true;
          this.stepOne = true;
          this.stepTwo = true;
          this.stepThree = true;
          this.stepFour = true;
          this.stepFive = true;
          this.stepNine = true;
          break;
      }
    }
  }
  adminInfoClickTab() {


  }

  agencyInfoClickTab() {
  }


  backOfficeClickTab() {
  }
  AgencyRightsClickTab() {
    for (let k = 0; k < this.reportTypesAgency.length; k++) {
      for (let j = 0; j < this.reportTypesUser.length; j++) {
        if (this.reportTypesUser[j].reportTypes == this.reportTypesAgency[k].reportTypes) {
          this.reportTypesUser[j].statusForUser = this.reportTypesAgency[k].status;
          this.reportTypesUser[j].status = this.reportTypesAgency[k].status;
        }
      }
    }

    this.GetparentAgencyRights();
    this.adminrightifagencynot();


  }
  managerInfoClickTab() {
  }
  supplierRightsClickTab() {

    this.managerInfoComplete = false;
    this.supplierRightsComplete = true;
    this.stepSix = true;
    this.GetparentAgencyRights();
    this.GetSuppliersByParent();
  }
  AddNewSupplierOfficeId(index: number) {

    if (this.agencySuppliers[index].supplierBoolean.length < this.agencySuppliers[index].supplierOfficeIdsCounter) {
      let supplierBool = new SupplierRightsForAgencyAndBranchBooleanProperties();
      this.agencySuppliers[index].supplierBoolean.push(supplierBool);

    }
    else {
      document.getElementById(`suppliers_Add-Error${index}`).innerHTML = "You Can't Add More Suppliers";
      setTimeout(() => {
        document.getElementById(`suppliers_Add-Error${index}`).innerHTML = "";
      }, 5000);

    }

  }
  AddNewInsuranceSupplierOfficeId(index: number) {

    if (this.insuranceSuppliers[index].supplierBoolean.length < this.insuranceSuppliers[index].supplierOfficeIdsCounter) {
      let supplierBool = new SupplierRightsForAgencyAndBranchBooleanProperties();
      this.insuranceSuppliers[index].supplierBoolean.push(supplierBool);

    }
    else {
      document.getElementById(`suppliers_Add-Error${index}`).innerHTML = "You Can't Add More Suppliers";
      setTimeout(() => {
        document.getElementById(`suppliers_Add-Error${index}`).innerHTML = "";
      }, 5000);

    }

  }
  RemoveInsuranceSupplierOfficeId(index: number, JIndex: number) {
    this.insuranceSuppliers[index].supplierBoolean.splice(JIndex, 1)

  }

  RemoveSupplierOfficeId(index: number, JIndex: number) {
    this.agencySuppliers[index].supplierBoolean.splice(JIndex, 1)

  }
  //10-June-24
  GroupTicketRightCheckManage = (event: any): void => {
    if (event.target.checked == false) {
      this.agencyObj.agencyRightObj.groupTicketRight = false;
      this.agencyObj.agencyRightObj.groupTicketListRight = false;
      this.agencyObj.agencyRightObj.groupTicketCreateRight = false;
      this.agencyObj.userObj.adminUser.groupTicketRight = false;
      this.agencyObj.userObj.adminUser.groupTicketListRight = false;
      this.agencyObj.userObj.adminUser.groupTicketCreateRight = false;
      this.agencyObj.agencyRightObj.groupTicketShowRight = false;
      this.agencyObj.userObj.adminUser.groupTicketShowRight = false;
    }
  }
  GroupTicketAdminRightCheckManage = (event: any): void => {
    if (event.target.checked == false) {
      this.agencyObj.userObj.adminUser.groupTicketRight = false;
      this.agencyObj.userObj.adminUser.groupTicketListRight = false;
      this.agencyObj.userObj.adminUser.groupTicketCreateRight = false;
      this.agencyObj.userObj.adminUser.groupTicketShowRight = false;
    }
  }

  GroupTicketAdminGroupTicketListRightCheckManage = (event: any): void => {
    if (event.target.checked == false) {
      this.agencyObj.userObj.adminUser.groupTicketListRight = false;
    }
  }

  GroupTicketAdminGroupTicketCreateRightCheckManage = (event: any): void => {
    if (event.target.checked == false) {
      this.agencyObj.userObj.adminUser.groupTicketCreateRight = false;
    }
  }


  GroupTicketAdminGroupTicketShowRightCheckManage = (event: any): void => {
    if (event.target.checked == false) {
      this.agencyObj.userObj.adminUser.groupTicketShowRight = false;
    }
  }
  //end
  ChangeApprovePayment = (event: any): void => {
    if (event.target.checked == false) {
      this.agencyObj.userObj.adminUser.approvePayment = false;
      this.agencyObj.userObj.adminUser.beneficiaryAccount = false;
    }
  }
  //end
  InsuranceCheckManage = (event: any): void => {
    if (event.target.checked == false) {
      this.agencyObj.agencyRightObj.insuranceRight = false;
      //this.agencyObj.agencyRightObj.insuranceIssuanceRight = false;
      //this.agencyObj.agencyRightObj.insuranceBookedViewRight = false;
      //this.agencyObj.agencyRightObj.insuranceCancelRight = false;
    }
    else if (event.target.checked == true) {
      this.agencyObj.agencyRightObj.insuranceRight = true;
      //this.agencyObj.agencyRightObj.insuranceIssuanceRight = true;
      //this.agencyObj.agencyRightObj.insuranceBookedViewRight = true;
      //this.agencyObj.agencyRightObj.insuranceCancelRight = true;
    }
  }
  InsuranceAdminRightCheckManage = (event: any): void => {
    if (event.target.checked == false) {
      this.agencyObj.userObj.adminUser.insuranceRight = false;
    }
    else if (event.target.checked == true) {
      this.agencyObj.userObj.adminUser.insuranceRight = true;
    }
  }
  IsRegisterBecomePartnerAdminRightCheckManage = (event: any): void => {
    if (event.target.checked == false) {
      this.agencyObj.userObj.adminUser.isRegisterBecomePartnerList = false;
    }
    else if (event.target.checked == true) {
      this.agencyObj.userObj.adminUser.isRegisterBecomePartnerList = true;
    }
  }
  offlineManageCheckboxChange(e) {
    if (e.target.checked == false) {
      this.agencyObj.agencyRightObj.offlineManageBooking = false;
      this.agencyObj.agencyRightObj.offlineManageRefund = false;
      this.agencyObj.agencyRightObj.offlineManageResissue = false;
      this.agencyObj.agencyRightObj.offlineManageTicket = false;
      this.agencyObj.agencyRightObj.offlineManageVoid = false;
      this.agencyObj.userObj.adminUser.offlineManage = false;
      this.agencyObj.userObj.adminUser.offlineManageBooking = false;
      this.agencyObj.userObj.adminUser.offlineManageRefund = false;
      this.agencyObj.userObj.adminUser.offlineManageResissue = false;
      this.agencyObj.userObj.adminUser.offlineManageTicket = false;
      this.agencyObj.userObj.adminUser.offlineManageVoid = false;
    }
  }
  offlineManageAdminCheckboxChange(e) {
    if (e.target.checked == false) {
      this.agencyObj.userObj.adminUser.offlineRequest = false;
      this.agencyObj.userObj.adminUser.offlineBooking = false;
      this.agencyObj.userObj.adminUser.offlineTicket = false;
      this.agencyObj.userObj.adminUser.offlineVoid = false;
      this.agencyObj.userObj.adminUser.offlineRefund = false;
      this.agencyObj.userObj.adminUser.offlineResissue = false;
      this.agencyObj.userObj.adminUser.offlineDealsByCMS = false;
    }
  }
}
